// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: schema_path/path_id.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { SchemaType, schemaTypeFromJSON, schemaTypeToJSON } from "./schema_path";

export const protobufPackage = "schema_path";

/** PathId identifies the specific "schema coordinates" identifier of an object in the schema tree. */
export interface PathId {
  /** Indicates that this object was deleted. */
  deleted: boolean;
  /** Optional string representation of the schema path.  Only populated on request. */
  pathString: string;
  type: SchemaType;
  fabric: string;
  device: string;
  fan: number;
  psu: number;
  tempSensor: number;
  lineCard: number;
  port: number;
  dacQsfp: number;
  fiberQsfp: number;
  breakout: number;
  portNeighbor: string;
  vtep: number;
  vniPort: number;
  mac: number;
  procTable: number;
  portVlan: string;
  vlanState: number;
  qsfpDomSensor: number;
  portConfig: number;
  nodeConfig: number;
  fabricConfig: string;
  fabricConfigEvent: number;
  l2Fdb: number;
  portCounters: number;
  remedyAction: string;
  qsfpInfo: number;
  fabricDevice: string;
  assertConfigPortLinkUp: number;
  assertPortLinkUp: number;
  assertConfigDeviceConnectedToCloud: number;
  assertDeviceConnectedToCloud: number;
  assertConfigPortExpectedNeighbor: number;
  assertPortExpectedNeighbor: number;
  assertConfigPortNotConnectedToFabric: number;
  assertPortNotConnectedToFabric: number;
  assertConfigDeviceConnectedToFabric: number;
  assertDeviceConnectedToFabric: number;
  assertConfigPortLinkDown: number;
  assertPortLinkDown: number;
  assertConfigPortConnectionSpeedMatch: number;
  assertPortConnectionSpeedMatch: number;
  assertConfigPortSpeedConsistent: number;
  assertPortSpeedConsistent: number;
  underlayInfo: number;
  proxyStats: number;
  vlanCounters: number;
  testPlaceHolder1Secret: number;
  assertConfigVlanHasTraffic: number;
  assertVlanHasTraffic: number;
  remoteVtep: number;
  qsfpDomThreshold: number;
  l3Table: string;
  vlanVniMap: number;
  proxyConnectionState: string;
  proxyConnectionStats: number;
  l2Mac: string;
  bmc: number;
  ipRouteTable: string;
  vrf: string;
  ipNextHop: number;
  ipPrefix: string;
  subInterface: number;
  assertConfigStaticDefaultRouteExists: number;
  assertStaticDefaultRouteExists: number;
  spyglassBrokerEntry: string;
  managementState: string;
  assertConfigManagementPortConfigSame: number;
  assertManagementPortConfigSame: number;
  fabricConfigNotification: number;
  spyglassGingerEntry: number;
  plannedConfig: number;
  routedInterfaceCounters: number;
  ipmRawLatencyCounters: number;
  ipmProcLatencyCounters: number;
  ipmProcLossCounters: number;
  ipmLivenessCounters: number;
  ipmSessionId: string;
  ipmProcJitterCounters: number;
  systemStats: number;
  testRootOne: string;
  testRootTwo: string;
  testMidOne: number;
  testLeafOne: string;
  testIpAddress: string;
  testIpPrefix: string;
  testMacAddress: string;
  assertConfigDeviceResourceUsageBelowThreshold: number;
  assertDeviceResourceUsageBelowThreshold: number;
  fabricTransaction: string;
  bgpNeighborSummary: string;
  deviceConnection: number;
  bgpNeighborFamily: number;
  assertConfigBgpPeerEstablished: number;
  assertBgpPeerEstablished: number;
  spyglassSshSessionEntry: number;
  portChannelMemberState: string;
  portChannelState: string;
  spyglassDevice: string;
  spyglassTcpListener: number;
  spyglassTcpSession: number;
  unknownVlan: number;
  unknownVlanPort: string;
  assertConfigExpectedPortBreakoutExists: number;
  assertExpectedPortBreakoutExists: number;
  assertConfigSubInterfaceUp: number;
  assertSubInterfaceUp: number;
  assertSubInterfaceDown: number;
  assertConfigSubInterfaceDown: number;
  deviceClaim: number;
  aggregatedDeviceClaim: string;
  assertPortChannelMemberUp: number;
  assertConfigPortChannelMemberUp: number;
  esiInfo: string;
  esiVtepInfo: string;
  assertPortVlanStpStateConsistent: number;
  assertConfigPortVlanStpStateConsistent: number;
  assertPortPluggablePidSame: number;
  assertConfigPortPluggablePidSame: number;
  manifestImageState: number;
  portRateCounters: number;
  authorizedUserEntry: string;
  delegatedReadOnlyUserEntry: string;
  orgUuid: string;
  fabricUuid: string;
  apiPath: string;
  apiPathMethod: string;
  apiServiceMapping: number;
  orgToCellPairMapping: number;
  tenantUuid: string;
  userEmail: string;
  managementConfig: number;
  serviceInstanceHealth: string;
  assignmentStatus: string;
  kubernetesServiceInstance: string;
  bearerToken: string;
  apiKey: string;
  fabricMemoryUsage: string;
  typeMemoryUsage: number;
  manifestRunningImageStatus: number;
  manifestPartitionFileCacheStatus: string;
  stpPortState: string;
  stpVlanState: number;
  stpVlanPortState: string;
  unpackAndAssembleTask: number;
  claimAndBindTask: number;
  portSetupTask: number;
  fabricConnectionTask: number;
  negativeConnectionTask: number;
  application: number;
  resourceAssignment: string;
  node: string;
  nodeLineCard: number;
  nodePort: number;
  nodeBreakout: number;
  tenantMetadata: number;
  assertPortNoUnknownVlanFound: number;
  assertConfigPortNoUnknownVlanFound: number;
  bulkUpliftJobRequest: string;
  bulkUpliftJobStatus: string;
  bgpNeighborInfo: string;
  refPoint: string;
  refPointStatus: string;
  userPreferenceItem: string;
  bgpNeighborReceivedRoute: string;
  userEula: string;
  brigSymmetricSigningKey: number;
  firmwareVersion: number;
  serverIpRouteAddress: string;
  serverIpRouteTable: string;
  apiPathProtocol: number;
  serverPsu: string;
  serverTempSensor: number;
  loadBalancedSvcRoute: number;
  assignmentSvcRoute: string;
  dbTableUpdateNotification: number;
  assertDeviceFanSpeedBelowThreshold: number;
  assertConfigDeviceFanSpeedBelowThreshold: number;
  assertDeviceTemperatureBelowThreshold: number;
  assertConfigDeviceTemperatureBelowThreshold: number;
  activeWorker: string;
  serverFan: number;
  serverPortInfo: number;
  assertDevicePsuUsageBelowThreshold: number;
  assertConfigDevicePsuUsageBelowThreshold: number;
  bmcServer: string;
  bmcServerPsu: string;
  bmcServerTempSensor: number;
  bmcServerFan: number;
  bmcServerPortInfo: number;
  ipRouteJoinedView: number;
  serverToBmc: number;
  serverMac: string;
  serverInterface: string;
  serverL3Table: string;
  serverInterfaceInfo: string;
  pluggableConnectionInfo: number;
  ipRouteJoinedViewCountSpace: string;
  ipRouteJoinedViewCount: number;
  l2FdbBucketed: string;
  l2FdbSingle: string;
  l2FdbSingleVlan: number;
  signingKey: string;
  bgpNeighborAdvertisedRoute: string;
  serverInterfaceMapping: number;
  signingKeyFlavor: number;
  ipSlaProbe: string;
  staticRoute: string;
  interconnect: string;
  interconnectTransaction: string;
  orgMetadata: number;
  fabricInterconnectConfig: string;
  spanSession: string;
  portVlanInfo: number;
  bgpRouteStats: number;
  vniMacCounts: number;
  gpuDevice: number;
  vxlanTunnel: string;
  vxlanTunnelMapping: string;
  vxlanRemoteVtepMapping: string;
  assertConfigMultisiteLinkUp: number;
  assertMultisiteLinkUp: number;
  multisiteLink: string;
  twampSession: number;
  assertConfigPortQsfpHealthy: number;
  assertPortQsfpHealthy: number;
  assertConfigMultisiteLatencyStable: number;
  assertMultisiteLatencyStable: number;
  l2FdbBucketedMultisite: string;
  commandRequest: string;
  commandOutput: string;
  commandOutputRecord: number;
  assertConfigMultisiteExpectedMtu: number;
  assertMultisiteExpectedMtu: number;
  imageManifestInfo: number;
  ipRouteFabricJoinedViewCountSpace: string;
  ipRouteFabricJoinedViewCount: number;
  borderPort: number;
  networkInterfaceSummary: string;
  vrfEndpointCounts: string;
  assertConfigNxosDeviceExpectedFeatures: number;
  assertNxosDeviceExpectedFeatures: number;
  opticsFirmwareUpdate: number;
  arsConfig: string;
  softwareUpdateStatus: number;
  vxlanRemoteVtepInfo: string;
  arsInfo: number;
  cellPair: string;
  arsPortInfo: number;
  fabricRack: string;
  iterativeSpiderClaim: string;
  invalidUserSession: string;
  systemHealth: number;
  portVlanAssertSummary: string;
  serverNetworkAdapter: string;
  bmcServerNetworkAdapter: string;
  serverProcessor: string;
  bmcServerProcessor: string;
}

function createBasePathId(): PathId {
  return {
    deleted: false,
    pathString: "",
    type: 0,
    fabric: "",
    device: "",
    fan: 0,
    psu: 0,
    tempSensor: 0,
    lineCard: 0,
    port: 0,
    dacQsfp: 0,
    fiberQsfp: 0,
    breakout: 0,
    portNeighbor: "",
    vtep: 0,
    vniPort: 0,
    mac: 0,
    procTable: 0,
    portVlan: "",
    vlanState: 0,
    qsfpDomSensor: 0,
    portConfig: 0,
    nodeConfig: 0,
    fabricConfig: "",
    fabricConfigEvent: 0,
    l2Fdb: 0,
    portCounters: 0,
    remedyAction: "",
    qsfpInfo: 0,
    fabricDevice: "",
    assertConfigPortLinkUp: 0,
    assertPortLinkUp: 0,
    assertConfigDeviceConnectedToCloud: 0,
    assertDeviceConnectedToCloud: 0,
    assertConfigPortExpectedNeighbor: 0,
    assertPortExpectedNeighbor: 0,
    assertConfigPortNotConnectedToFabric: 0,
    assertPortNotConnectedToFabric: 0,
    assertConfigDeviceConnectedToFabric: 0,
    assertDeviceConnectedToFabric: 0,
    assertConfigPortLinkDown: 0,
    assertPortLinkDown: 0,
    assertConfigPortConnectionSpeedMatch: 0,
    assertPortConnectionSpeedMatch: 0,
    assertConfigPortSpeedConsistent: 0,
    assertPortSpeedConsistent: 0,
    underlayInfo: 0,
    proxyStats: 0,
    vlanCounters: 0,
    testPlaceHolder1Secret: 0,
    assertConfigVlanHasTraffic: 0,
    assertVlanHasTraffic: 0,
    remoteVtep: 0,
    qsfpDomThreshold: 0,
    l3Table: "",
    vlanVniMap: 0,
    proxyConnectionState: "",
    proxyConnectionStats: 0,
    l2Mac: "",
    bmc: 0,
    ipRouteTable: "",
    vrf: "",
    ipNextHop: 0,
    ipPrefix: "",
    subInterface: 0,
    assertConfigStaticDefaultRouteExists: 0,
    assertStaticDefaultRouteExists: 0,
    spyglassBrokerEntry: "",
    managementState: "",
    assertConfigManagementPortConfigSame: 0,
    assertManagementPortConfigSame: 0,
    fabricConfigNotification: 0,
    spyglassGingerEntry: 0,
    plannedConfig: 0,
    routedInterfaceCounters: 0,
    ipmRawLatencyCounters: 0,
    ipmProcLatencyCounters: 0,
    ipmProcLossCounters: 0,
    ipmLivenessCounters: 0,
    ipmSessionId: "",
    ipmProcJitterCounters: 0,
    systemStats: 0,
    testRootOne: "",
    testRootTwo: "",
    testMidOne: 0,
    testLeafOne: "",
    testIpAddress: "",
    testIpPrefix: "",
    testMacAddress: "",
    assertConfigDeviceResourceUsageBelowThreshold: 0,
    assertDeviceResourceUsageBelowThreshold: 0,
    fabricTransaction: "0",
    bgpNeighborSummary: "",
    deviceConnection: 0,
    bgpNeighborFamily: 0,
    assertConfigBgpPeerEstablished: 0,
    assertBgpPeerEstablished: 0,
    spyglassSshSessionEntry: 0,
    portChannelMemberState: "",
    portChannelState: "",
    spyglassDevice: "",
    spyglassTcpListener: 0,
    spyglassTcpSession: 0,
    unknownVlan: 0,
    unknownVlanPort: "",
    assertConfigExpectedPortBreakoutExists: 0,
    assertExpectedPortBreakoutExists: 0,
    assertConfigSubInterfaceUp: 0,
    assertSubInterfaceUp: 0,
    assertSubInterfaceDown: 0,
    assertConfigSubInterfaceDown: 0,
    deviceClaim: 0,
    aggregatedDeviceClaim: "",
    assertPortChannelMemberUp: 0,
    assertConfigPortChannelMemberUp: 0,
    esiInfo: "",
    esiVtepInfo: "",
    assertPortVlanStpStateConsistent: 0,
    assertConfigPortVlanStpStateConsistent: 0,
    assertPortPluggablePidSame: 0,
    assertConfigPortPluggablePidSame: 0,
    manifestImageState: 0,
    portRateCounters: 0,
    authorizedUserEntry: "",
    delegatedReadOnlyUserEntry: "",
    orgUuid: "",
    fabricUuid: "",
    apiPath: "",
    apiPathMethod: "",
    apiServiceMapping: 0,
    orgToCellPairMapping: 0,
    tenantUuid: "",
    userEmail: "",
    managementConfig: 0,
    serviceInstanceHealth: "",
    assignmentStatus: "",
    kubernetesServiceInstance: "",
    bearerToken: "",
    apiKey: "",
    fabricMemoryUsage: "",
    typeMemoryUsage: 0,
    manifestRunningImageStatus: 0,
    manifestPartitionFileCacheStatus: "",
    stpPortState: "",
    stpVlanState: 0,
    stpVlanPortState: "",
    unpackAndAssembleTask: 0,
    claimAndBindTask: 0,
    portSetupTask: 0,
    fabricConnectionTask: 0,
    negativeConnectionTask: 0,
    application: 0,
    resourceAssignment: "",
    node: "",
    nodeLineCard: 0,
    nodePort: 0,
    nodeBreakout: 0,
    tenantMetadata: 0,
    assertPortNoUnknownVlanFound: 0,
    assertConfigPortNoUnknownVlanFound: 0,
    bulkUpliftJobRequest: "",
    bulkUpliftJobStatus: "",
    bgpNeighborInfo: "",
    refPoint: "",
    refPointStatus: "",
    userPreferenceItem: "",
    bgpNeighborReceivedRoute: "",
    userEula: "",
    brigSymmetricSigningKey: 0,
    firmwareVersion: 0,
    serverIpRouteAddress: "",
    serverIpRouteTable: "",
    apiPathProtocol: 0,
    serverPsu: "",
    serverTempSensor: 0,
    loadBalancedSvcRoute: 0,
    assignmentSvcRoute: "",
    dbTableUpdateNotification: 0,
    assertDeviceFanSpeedBelowThreshold: 0,
    assertConfigDeviceFanSpeedBelowThreshold: 0,
    assertDeviceTemperatureBelowThreshold: 0,
    assertConfigDeviceTemperatureBelowThreshold: 0,
    activeWorker: "",
    serverFan: 0,
    serverPortInfo: 0,
    assertDevicePsuUsageBelowThreshold: 0,
    assertConfigDevicePsuUsageBelowThreshold: 0,
    bmcServer: "",
    bmcServerPsu: "",
    bmcServerTempSensor: 0,
    bmcServerFan: 0,
    bmcServerPortInfo: 0,
    ipRouteJoinedView: 0,
    serverToBmc: 0,
    serverMac: "",
    serverInterface: "",
    serverL3Table: "",
    serverInterfaceInfo: "",
    pluggableConnectionInfo: 0,
    ipRouteJoinedViewCountSpace: "",
    ipRouteJoinedViewCount: 0,
    l2FdbBucketed: "",
    l2FdbSingle: "",
    l2FdbSingleVlan: 0,
    signingKey: "",
    bgpNeighborAdvertisedRoute: "",
    serverInterfaceMapping: 0,
    signingKeyFlavor: 0,
    ipSlaProbe: "",
    staticRoute: "",
    interconnect: "",
    interconnectTransaction: "0",
    orgMetadata: 0,
    fabricInterconnectConfig: "",
    spanSession: "",
    portVlanInfo: 0,
    bgpRouteStats: 0,
    vniMacCounts: 0,
    gpuDevice: 0,
    vxlanTunnel: "",
    vxlanTunnelMapping: "",
    vxlanRemoteVtepMapping: "",
    assertConfigMultisiteLinkUp: 0,
    assertMultisiteLinkUp: 0,
    multisiteLink: "",
    twampSession: 0,
    assertConfigPortQsfpHealthy: 0,
    assertPortQsfpHealthy: 0,
    assertConfigMultisiteLatencyStable: 0,
    assertMultisiteLatencyStable: 0,
    l2FdbBucketedMultisite: "",
    commandRequest: "",
    commandOutput: "",
    commandOutputRecord: 0,
    assertConfigMultisiteExpectedMtu: 0,
    assertMultisiteExpectedMtu: 0,
    imageManifestInfo: 0,
    ipRouteFabricJoinedViewCountSpace: "",
    ipRouteFabricJoinedViewCount: 0,
    borderPort: 0,
    networkInterfaceSummary: "",
    vrfEndpointCounts: "",
    assertConfigNxosDeviceExpectedFeatures: 0,
    assertNxosDeviceExpectedFeatures: 0,
    opticsFirmwareUpdate: 0,
    arsConfig: "",
    softwareUpdateStatus: 0,
    vxlanRemoteVtepInfo: "",
    arsInfo: 0,
    cellPair: "",
    arsPortInfo: 0,
    fabricRack: "",
    iterativeSpiderClaim: "",
    invalidUserSession: "",
    systemHealth: 0,
    portVlanAssertSummary: "",
    serverNetworkAdapter: "",
    bmcServerNetworkAdapter: "",
    serverProcessor: "",
    bmcServerProcessor: "",
  };
}

export const PathId: MessageFns<PathId> = {
  encode(message: PathId, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.deleted !== false) {
      writer.uint32(24).bool(message.deleted);
    }
    if (message.pathString !== "") {
      writer.uint32(34).string(message.pathString);
    }
    if (message.type !== 0) {
      writer.uint32(40).int32(message.type);
    }
    if (message.fabric !== "") {
      writer.uint32(194).string(message.fabric);
    }
    if (message.device !== "") {
      writer.uint32(202).string(message.device);
    }
    if (message.fan !== 0) {
      writer.uint32(208).uint32(message.fan);
    }
    if (message.psu !== 0) {
      writer.uint32(216).uint32(message.psu);
    }
    if (message.tempSensor !== 0) {
      writer.uint32(224).uint32(message.tempSensor);
    }
    if (message.lineCard !== 0) {
      writer.uint32(232).uint32(message.lineCard);
    }
    if (message.port !== 0) {
      writer.uint32(240).uint32(message.port);
    }
    if (message.dacQsfp !== 0) {
      writer.uint32(248).uint32(message.dacQsfp);
    }
    if (message.fiberQsfp !== 0) {
      writer.uint32(256).uint32(message.fiberQsfp);
    }
    if (message.breakout !== 0) {
      writer.uint32(264).uint32(message.breakout);
    }
    if (message.portNeighbor !== "") {
      writer.uint32(274).string(message.portNeighbor);
    }
    if (message.vtep !== 0) {
      writer.uint32(280).uint32(message.vtep);
    }
    if (message.vniPort !== 0) {
      writer.uint32(288).uint32(message.vniPort);
    }
    if (message.mac !== 0) {
      writer.uint32(296).uint32(message.mac);
    }
    if (message.procTable !== 0) {
      writer.uint32(304).uint32(message.procTable);
    }
    if (message.portVlan !== "") {
      writer.uint32(314).string(message.portVlan);
    }
    if (message.vlanState !== 0) {
      writer.uint32(320).uint32(message.vlanState);
    }
    if (message.qsfpDomSensor !== 0) {
      writer.uint32(336).uint32(message.qsfpDomSensor);
    }
    if (message.portConfig !== 0) {
      writer.uint32(376).uint32(message.portConfig);
    }
    if (message.nodeConfig !== 0) {
      writer.uint32(384).uint32(message.nodeConfig);
    }
    if (message.fabricConfig !== "") {
      writer.uint32(394).string(message.fabricConfig);
    }
    if (message.fabricConfigEvent !== 0) {
      writer.uint32(400).uint32(message.fabricConfigEvent);
    }
    if (message.l2Fdb !== 0) {
      writer.uint32(408).uint32(message.l2Fdb);
    }
    if (message.portCounters !== 0) {
      writer.uint32(416).uint32(message.portCounters);
    }
    if (message.remedyAction !== "") {
      writer.uint32(426).string(message.remedyAction);
    }
    if (message.qsfpInfo !== 0) {
      writer.uint32(432).uint32(message.qsfpInfo);
    }
    if (message.fabricDevice !== "") {
      writer.uint32(442).string(message.fabricDevice);
    }
    if (message.assertConfigPortLinkUp !== 0) {
      writer.uint32(448).uint32(message.assertConfigPortLinkUp);
    }
    if (message.assertPortLinkUp !== 0) {
      writer.uint32(456).uint32(message.assertPortLinkUp);
    }
    if (message.assertConfigDeviceConnectedToCloud !== 0) {
      writer.uint32(464).uint32(message.assertConfigDeviceConnectedToCloud);
    }
    if (message.assertDeviceConnectedToCloud !== 0) {
      writer.uint32(472).uint32(message.assertDeviceConnectedToCloud);
    }
    if (message.assertConfigPortExpectedNeighbor !== 0) {
      writer.uint32(480).uint32(message.assertConfigPortExpectedNeighbor);
    }
    if (message.assertPortExpectedNeighbor !== 0) {
      writer.uint32(488).uint32(message.assertPortExpectedNeighbor);
    }
    if (message.assertConfigPortNotConnectedToFabric !== 0) {
      writer.uint32(496).uint32(message.assertConfigPortNotConnectedToFabric);
    }
    if (message.assertPortNotConnectedToFabric !== 0) {
      writer.uint32(504).uint32(message.assertPortNotConnectedToFabric);
    }
    if (message.assertConfigDeviceConnectedToFabric !== 0) {
      writer.uint32(512).uint32(message.assertConfigDeviceConnectedToFabric);
    }
    if (message.assertDeviceConnectedToFabric !== 0) {
      writer.uint32(520).uint32(message.assertDeviceConnectedToFabric);
    }
    if (message.assertConfigPortLinkDown !== 0) {
      writer.uint32(528).uint32(message.assertConfigPortLinkDown);
    }
    if (message.assertPortLinkDown !== 0) {
      writer.uint32(536).uint32(message.assertPortLinkDown);
    }
    if (message.assertConfigPortConnectionSpeedMatch !== 0) {
      writer.uint32(544).uint32(message.assertConfigPortConnectionSpeedMatch);
    }
    if (message.assertPortConnectionSpeedMatch !== 0) {
      writer.uint32(552).uint32(message.assertPortConnectionSpeedMatch);
    }
    if (message.assertConfigPortSpeedConsistent !== 0) {
      writer.uint32(560).uint32(message.assertConfigPortSpeedConsistent);
    }
    if (message.assertPortSpeedConsistent !== 0) {
      writer.uint32(568).uint32(message.assertPortSpeedConsistent);
    }
    if (message.underlayInfo !== 0) {
      writer.uint32(584).uint32(message.underlayInfo);
    }
    if (message.proxyStats !== 0) {
      writer.uint32(592).uint32(message.proxyStats);
    }
    if (message.vlanCounters !== 0) {
      writer.uint32(600).uint32(message.vlanCounters);
    }
    if (message.testPlaceHolder1Secret !== 0) {
      writer.uint32(608).uint32(message.testPlaceHolder1Secret);
    }
    if (message.assertConfigVlanHasTraffic !== 0) {
      writer.uint32(616).uint32(message.assertConfigVlanHasTraffic);
    }
    if (message.assertVlanHasTraffic !== 0) {
      writer.uint32(624).uint32(message.assertVlanHasTraffic);
    }
    if (message.remoteVtep !== 0) {
      writer.uint32(632).uint32(message.remoteVtep);
    }
    if (message.qsfpDomThreshold !== 0) {
      writer.uint32(640).uint32(message.qsfpDomThreshold);
    }
    if (message.l3Table !== "") {
      writer.uint32(658).string(message.l3Table);
    }
    if (message.vlanVniMap !== 0) {
      writer.uint32(664).uint32(message.vlanVniMap);
    }
    if (message.proxyConnectionState !== "") {
      writer.uint32(674).string(message.proxyConnectionState);
    }
    if (message.proxyConnectionStats !== 0) {
      writer.uint32(680).uint32(message.proxyConnectionStats);
    }
    if (message.l2Mac !== "") {
      writer.uint32(690).string(message.l2Mac);
    }
    if (message.bmc !== 0) {
      writer.uint32(696).uint32(message.bmc);
    }
    if (message.ipRouteTable !== "") {
      writer.uint32(730).string(message.ipRouteTable);
    }
    if (message.vrf !== "") {
      writer.uint32(738).string(message.vrf);
    }
    if (message.ipNextHop !== 0) {
      writer.uint32(744).uint32(message.ipNextHop);
    }
    if (message.ipPrefix !== "") {
      writer.uint32(754).string(message.ipPrefix);
    }
    if (message.subInterface !== 0) {
      writer.uint32(760).uint32(message.subInterface);
    }
    if (message.assertConfigStaticDefaultRouteExists !== 0) {
      writer.uint32(768).uint32(message.assertConfigStaticDefaultRouteExists);
    }
    if (message.assertStaticDefaultRouteExists !== 0) {
      writer.uint32(776).uint32(message.assertStaticDefaultRouteExists);
    }
    if (message.spyglassBrokerEntry !== "") {
      writer.uint32(786).string(message.spyglassBrokerEntry);
    }
    if (message.managementState !== "") {
      writer.uint32(794).string(message.managementState);
    }
    if (message.assertConfigManagementPortConfigSame !== 0) {
      writer.uint32(816).uint32(message.assertConfigManagementPortConfigSame);
    }
    if (message.assertManagementPortConfigSame !== 0) {
      writer.uint32(824).uint32(message.assertManagementPortConfigSame);
    }
    if (message.fabricConfigNotification !== 0) {
      writer.uint32(832).uint32(message.fabricConfigNotification);
    }
    if (message.spyglassGingerEntry !== 0) {
      writer.uint32(840).uint32(message.spyglassGingerEntry);
    }
    if (message.plannedConfig !== 0) {
      writer.uint32(848).uint32(message.plannedConfig);
    }
    if (message.routedInterfaceCounters !== 0) {
      writer.uint32(856).uint32(message.routedInterfaceCounters);
    }
    if (message.ipmRawLatencyCounters !== 0) {
      writer.uint32(864).uint32(message.ipmRawLatencyCounters);
    }
    if (message.ipmProcLatencyCounters !== 0) {
      writer.uint32(872).uint32(message.ipmProcLatencyCounters);
    }
    if (message.ipmProcLossCounters !== 0) {
      writer.uint32(880).uint32(message.ipmProcLossCounters);
    }
    if (message.ipmLivenessCounters !== 0) {
      writer.uint32(888).uint32(message.ipmLivenessCounters);
    }
    if (message.ipmSessionId !== "") {
      writer.uint32(898).string(message.ipmSessionId);
    }
    if (message.ipmProcJitterCounters !== 0) {
      writer.uint32(904).uint32(message.ipmProcJitterCounters);
    }
    if (message.systemStats !== 0) {
      writer.uint32(952).uint32(message.systemStats);
    }
    if (message.testRootOne !== "") {
      writer.uint32(962).string(message.testRootOne);
    }
    if (message.testRootTwo !== "") {
      writer.uint32(970).string(message.testRootTwo);
    }
    if (message.testMidOne !== 0) {
      writer.uint32(976).uint32(message.testMidOne);
    }
    if (message.testLeafOne !== "") {
      writer.uint32(994).string(message.testLeafOne);
    }
    if (message.testIpAddress !== "") {
      writer.uint32(1010).string(message.testIpAddress);
    }
    if (message.testIpPrefix !== "") {
      writer.uint32(1018).string(message.testIpPrefix);
    }
    if (message.testMacAddress !== "") {
      writer.uint32(1026).string(message.testMacAddress);
    }
    if (message.assertConfigDeviceResourceUsageBelowThreshold !== 0) {
      writer.uint32(1032).uint32(message.assertConfigDeviceResourceUsageBelowThreshold);
    }
    if (message.assertDeviceResourceUsageBelowThreshold !== 0) {
      writer.uint32(1040).uint32(message.assertDeviceResourceUsageBelowThreshold);
    }
    if (message.fabricTransaction !== "0") {
      writer.uint32(1048).int64(message.fabricTransaction);
    }
    if (message.bgpNeighborSummary !== "") {
      writer.uint32(1066).string(message.bgpNeighborSummary);
    }
    if (message.deviceConnection !== 0) {
      writer.uint32(1080).uint32(message.deviceConnection);
    }
    if (message.bgpNeighborFamily !== 0) {
      writer.uint32(1088).uint32(message.bgpNeighborFamily);
    }
    if (message.assertConfigBgpPeerEstablished !== 0) {
      writer.uint32(1096).uint32(message.assertConfigBgpPeerEstablished);
    }
    if (message.assertBgpPeerEstablished !== 0) {
      writer.uint32(1104).uint32(message.assertBgpPeerEstablished);
    }
    if (message.spyglassSshSessionEntry !== 0) {
      writer.uint32(1112).uint32(message.spyglassSshSessionEntry);
    }
    if (message.portChannelMemberState !== "") {
      writer.uint32(1122).string(message.portChannelMemberState);
    }
    if (message.portChannelState !== "") {
      writer.uint32(1130).string(message.portChannelState);
    }
    if (message.spyglassDevice !== "") {
      writer.uint32(1170).string(message.spyglassDevice);
    }
    if (message.spyglassTcpListener !== 0) {
      writer.uint32(1176).uint32(message.spyglassTcpListener);
    }
    if (message.spyglassTcpSession !== 0) {
      writer.uint32(1184).uint32(message.spyglassTcpSession);
    }
    if (message.unknownVlan !== 0) {
      writer.uint32(1192).uint32(message.unknownVlan);
    }
    if (message.unknownVlanPort !== "") {
      writer.uint32(1202).string(message.unknownVlanPort);
    }
    if (message.assertConfigExpectedPortBreakoutExists !== 0) {
      writer.uint32(1208).uint32(message.assertConfigExpectedPortBreakoutExists);
    }
    if (message.assertExpectedPortBreakoutExists !== 0) {
      writer.uint32(1216).uint32(message.assertExpectedPortBreakoutExists);
    }
    if (message.assertConfigSubInterfaceUp !== 0) {
      writer.uint32(1224).uint32(message.assertConfigSubInterfaceUp);
    }
    if (message.assertSubInterfaceUp !== 0) {
      writer.uint32(1232).uint32(message.assertSubInterfaceUp);
    }
    if (message.assertSubInterfaceDown !== 0) {
      writer.uint32(1240).uint32(message.assertSubInterfaceDown);
    }
    if (message.assertConfigSubInterfaceDown !== 0) {
      writer.uint32(1248).uint32(message.assertConfigSubInterfaceDown);
    }
    if (message.deviceClaim !== 0) {
      writer.uint32(1264).uint32(message.deviceClaim);
    }
    if (message.aggregatedDeviceClaim !== "") {
      writer.uint32(1274).string(message.aggregatedDeviceClaim);
    }
    if (message.assertPortChannelMemberUp !== 0) {
      writer.uint32(1280).uint32(message.assertPortChannelMemberUp);
    }
    if (message.assertConfigPortChannelMemberUp !== 0) {
      writer.uint32(1288).uint32(message.assertConfigPortChannelMemberUp);
    }
    if (message.esiInfo !== "") {
      writer.uint32(1298).string(message.esiInfo);
    }
    if (message.esiVtepInfo !== "") {
      writer.uint32(1306).string(message.esiVtepInfo);
    }
    if (message.assertPortVlanStpStateConsistent !== 0) {
      writer.uint32(1312).uint32(message.assertPortVlanStpStateConsistent);
    }
    if (message.assertConfigPortVlanStpStateConsistent !== 0) {
      writer.uint32(1320).uint32(message.assertConfigPortVlanStpStateConsistent);
    }
    if (message.assertPortPluggablePidSame !== 0) {
      writer.uint32(1328).uint32(message.assertPortPluggablePidSame);
    }
    if (message.assertConfigPortPluggablePidSame !== 0) {
      writer.uint32(1336).uint32(message.assertConfigPortPluggablePidSame);
    }
    if (message.manifestImageState !== 0) {
      writer.uint32(1360).uint32(message.manifestImageState);
    }
    if (message.portRateCounters !== 0) {
      writer.uint32(1368).uint32(message.portRateCounters);
    }
    if (message.authorizedUserEntry !== "") {
      writer.uint32(1378).string(message.authorizedUserEntry);
    }
    if (message.delegatedReadOnlyUserEntry !== "") {
      writer.uint32(1386).string(message.delegatedReadOnlyUserEntry);
    }
    if (message.orgUuid !== "") {
      writer.uint32(1762).string(message.orgUuid);
    }
    if (message.fabricUuid !== "") {
      writer.uint32(1770).string(message.fabricUuid);
    }
    if (message.apiPath !== "") {
      writer.uint32(1802).string(message.apiPath);
    }
    if (message.apiPathMethod !== "") {
      writer.uint32(1810).string(message.apiPathMethod);
    }
    if (message.apiServiceMapping !== 0) {
      writer.uint32(1816).uint32(message.apiServiceMapping);
    }
    if (message.orgToCellPairMapping !== 0) {
      writer.uint32(1824).uint32(message.orgToCellPairMapping);
    }
    if (message.tenantUuid !== "") {
      writer.uint32(1834).string(message.tenantUuid);
    }
    if (message.userEmail !== "") {
      writer.uint32(1842).string(message.userEmail);
    }
    if (message.managementConfig !== 0) {
      writer.uint32(1848).uint32(message.managementConfig);
    }
    if (message.serviceInstanceHealth !== "") {
      writer.uint32(1858).string(message.serviceInstanceHealth);
    }
    if (message.assignmentStatus !== "") {
      writer.uint32(1866).string(message.assignmentStatus);
    }
    if (message.kubernetesServiceInstance !== "") {
      writer.uint32(1882).string(message.kubernetesServiceInstance);
    }
    if (message.bearerToken !== "") {
      writer.uint32(1938).string(message.bearerToken);
    }
    if (message.apiKey !== "") {
      writer.uint32(1946).string(message.apiKey);
    }
    if (message.fabricMemoryUsage !== "") {
      writer.uint32(1954).string(message.fabricMemoryUsage);
    }
    if (message.typeMemoryUsage !== 0) {
      writer.uint32(1960).uint32(message.typeMemoryUsage);
    }
    if (message.manifestRunningImageStatus !== 0) {
      writer.uint32(1968).uint32(message.manifestRunningImageStatus);
    }
    if (message.manifestPartitionFileCacheStatus !== "") {
      writer.uint32(1978).string(message.manifestPartitionFileCacheStatus);
    }
    if (message.stpPortState !== "") {
      writer.uint32(1986).string(message.stpPortState);
    }
    if (message.stpVlanState !== 0) {
      writer.uint32(1992).uint32(message.stpVlanState);
    }
    if (message.stpVlanPortState !== "") {
      writer.uint32(2002).string(message.stpVlanPortState);
    }
    if (message.unpackAndAssembleTask !== 0) {
      writer.uint32(2064).uint32(message.unpackAndAssembleTask);
    }
    if (message.claimAndBindTask !== 0) {
      writer.uint32(2080).uint32(message.claimAndBindTask);
    }
    if (message.portSetupTask !== 0) {
      writer.uint32(2088).uint32(message.portSetupTask);
    }
    if (message.fabricConnectionTask !== 0) {
      writer.uint32(2096).uint32(message.fabricConnectionTask);
    }
    if (message.negativeConnectionTask !== 0) {
      writer.uint32(2104).uint32(message.negativeConnectionTask);
    }
    if (message.application !== 0) {
      writer.uint32(2112).uint32(message.application);
    }
    if (message.resourceAssignment !== "") {
      writer.uint32(2122).string(message.resourceAssignment);
    }
    if (message.node !== "") {
      writer.uint32(2130).string(message.node);
    }
    if (message.nodeLineCard !== 0) {
      writer.uint32(2136).uint32(message.nodeLineCard);
    }
    if (message.nodePort !== 0) {
      writer.uint32(2144).uint32(message.nodePort);
    }
    if (message.nodeBreakout !== 0) {
      writer.uint32(2152).uint32(message.nodeBreakout);
    }
    if (message.tenantMetadata !== 0) {
      writer.uint32(2160).uint32(message.tenantMetadata);
    }
    if (message.assertPortNoUnknownVlanFound !== 0) {
      writer.uint32(2168).uint32(message.assertPortNoUnknownVlanFound);
    }
    if (message.assertConfigPortNoUnknownVlanFound !== 0) {
      writer.uint32(2176).uint32(message.assertConfigPortNoUnknownVlanFound);
    }
    if (message.bulkUpliftJobRequest !== "") {
      writer.uint32(2186).string(message.bulkUpliftJobRequest);
    }
    if (message.bulkUpliftJobStatus !== "") {
      writer.uint32(2194).string(message.bulkUpliftJobStatus);
    }
    if (message.bgpNeighborInfo !== "") {
      writer.uint32(2202).string(message.bgpNeighborInfo);
    }
    if (message.refPoint !== "") {
      writer.uint32(2210).string(message.refPoint);
    }
    if (message.refPointStatus !== "") {
      writer.uint32(2218).string(message.refPointStatus);
    }
    if (message.userPreferenceItem !== "") {
      writer.uint32(2226).string(message.userPreferenceItem);
    }
    if (message.bgpNeighborReceivedRoute !== "") {
      writer.uint32(2234).string(message.bgpNeighborReceivedRoute);
    }
    if (message.userEula !== "") {
      writer.uint32(2242).string(message.userEula);
    }
    if (message.brigSymmetricSigningKey !== 0) {
      writer.uint32(2248).uint32(message.brigSymmetricSigningKey);
    }
    if (message.firmwareVersion !== 0) {
      writer.uint32(2256).uint32(message.firmwareVersion);
    }
    if (message.serverIpRouteAddress !== "") {
      writer.uint32(2266).string(message.serverIpRouteAddress);
    }
    if (message.serverIpRouteTable !== "") {
      writer.uint32(2274).string(message.serverIpRouteTable);
    }
    if (message.apiPathProtocol !== 0) {
      writer.uint32(2280).uint32(message.apiPathProtocol);
    }
    if (message.serverPsu !== "") {
      writer.uint32(2290).string(message.serverPsu);
    }
    if (message.serverTempSensor !== 0) {
      writer.uint32(2296).uint32(message.serverTempSensor);
    }
    if (message.loadBalancedSvcRoute !== 0) {
      writer.uint32(2304).uint32(message.loadBalancedSvcRoute);
    }
    if (message.assignmentSvcRoute !== "") {
      writer.uint32(2314).string(message.assignmentSvcRoute);
    }
    if (message.dbTableUpdateNotification !== 0) {
      writer.uint32(2320).uint32(message.dbTableUpdateNotification);
    }
    if (message.assertDeviceFanSpeedBelowThreshold !== 0) {
      writer.uint32(2328).uint32(message.assertDeviceFanSpeedBelowThreshold);
    }
    if (message.assertConfigDeviceFanSpeedBelowThreshold !== 0) {
      writer.uint32(2336).uint32(message.assertConfigDeviceFanSpeedBelowThreshold);
    }
    if (message.assertDeviceTemperatureBelowThreshold !== 0) {
      writer.uint32(2344).uint32(message.assertDeviceTemperatureBelowThreshold);
    }
    if (message.assertConfigDeviceTemperatureBelowThreshold !== 0) {
      writer.uint32(2352).uint32(message.assertConfigDeviceTemperatureBelowThreshold);
    }
    if (message.activeWorker !== "") {
      writer.uint32(2362).string(message.activeWorker);
    }
    if (message.serverFan !== 0) {
      writer.uint32(2368).uint32(message.serverFan);
    }
    if (message.serverPortInfo !== 0) {
      writer.uint32(2376).uint32(message.serverPortInfo);
    }
    if (message.assertDevicePsuUsageBelowThreshold !== 0) {
      writer.uint32(2384).uint32(message.assertDevicePsuUsageBelowThreshold);
    }
    if (message.assertConfigDevicePsuUsageBelowThreshold !== 0) {
      writer.uint32(2392).uint32(message.assertConfigDevicePsuUsageBelowThreshold);
    }
    if (message.bmcServer !== "") {
      writer.uint32(2402).string(message.bmcServer);
    }
    if (message.bmcServerPsu !== "") {
      writer.uint32(2410).string(message.bmcServerPsu);
    }
    if (message.bmcServerTempSensor !== 0) {
      writer.uint32(2416).uint32(message.bmcServerTempSensor);
    }
    if (message.bmcServerFan !== 0) {
      writer.uint32(2424).uint32(message.bmcServerFan);
    }
    if (message.bmcServerPortInfo !== 0) {
      writer.uint32(2432).uint32(message.bmcServerPortInfo);
    }
    if (message.ipRouteJoinedView !== 0) {
      writer.uint32(2440).uint32(message.ipRouteJoinedView);
    }
    if (message.serverToBmc !== 0) {
      writer.uint32(2448).uint32(message.serverToBmc);
    }
    if (message.serverMac !== "") {
      writer.uint32(2458).string(message.serverMac);
    }
    if (message.serverInterface !== "") {
      writer.uint32(2466).string(message.serverInterface);
    }
    if (message.serverL3Table !== "") {
      writer.uint32(2474).string(message.serverL3Table);
    }
    if (message.serverInterfaceInfo !== "") {
      writer.uint32(2482).string(message.serverInterfaceInfo);
    }
    if (message.pluggableConnectionInfo !== 0) {
      writer.uint32(2496).uint32(message.pluggableConnectionInfo);
    }
    if (message.ipRouteJoinedViewCountSpace !== "") {
      writer.uint32(2506).string(message.ipRouteJoinedViewCountSpace);
    }
    if (message.ipRouteJoinedViewCount !== 0) {
      writer.uint32(2512).uint32(message.ipRouteJoinedViewCount);
    }
    if (message.l2FdbBucketed !== "") {
      writer.uint32(2522).string(message.l2FdbBucketed);
    }
    if (message.l2FdbSingle !== "") {
      writer.uint32(2530).string(message.l2FdbSingle);
    }
    if (message.l2FdbSingleVlan !== 0) {
      writer.uint32(2536).uint32(message.l2FdbSingleVlan);
    }
    if (message.signingKey !== "") {
      writer.uint32(2546).string(message.signingKey);
    }
    if (message.bgpNeighborAdvertisedRoute !== "") {
      writer.uint32(2554).string(message.bgpNeighborAdvertisedRoute);
    }
    if (message.serverInterfaceMapping !== 0) {
      writer.uint32(2560).uint32(message.serverInterfaceMapping);
    }
    if (message.signingKeyFlavor !== 0) {
      writer.uint32(2568).uint32(message.signingKeyFlavor);
    }
    if (message.ipSlaProbe !== "") {
      writer.uint32(2578).string(message.ipSlaProbe);
    }
    if (message.staticRoute !== "") {
      writer.uint32(2586).string(message.staticRoute);
    }
    if (message.interconnect !== "") {
      writer.uint32(2594).string(message.interconnect);
    }
    if (message.interconnectTransaction !== "0") {
      writer.uint32(2600).int64(message.interconnectTransaction);
    }
    if (message.orgMetadata !== 0) {
      writer.uint32(2608).uint32(message.orgMetadata);
    }
    if (message.fabricInterconnectConfig !== "") {
      writer.uint32(2618).string(message.fabricInterconnectConfig);
    }
    if (message.spanSession !== "") {
      writer.uint32(2626).string(message.spanSession);
    }
    if (message.portVlanInfo !== 0) {
      writer.uint32(2632).uint32(message.portVlanInfo);
    }
    if (message.bgpRouteStats !== 0) {
      writer.uint32(2648).uint32(message.bgpRouteStats);
    }
    if (message.vniMacCounts !== 0) {
      writer.uint32(2656).uint32(message.vniMacCounts);
    }
    if (message.gpuDevice !== 0) {
      writer.uint32(2664).uint32(message.gpuDevice);
    }
    if (message.vxlanTunnel !== "") {
      writer.uint32(2674).string(message.vxlanTunnel);
    }
    if (message.vxlanTunnelMapping !== "") {
      writer.uint32(2682).string(message.vxlanTunnelMapping);
    }
    if (message.vxlanRemoteVtepMapping !== "") {
      writer.uint32(2690).string(message.vxlanRemoteVtepMapping);
    }
    if (message.assertConfigMultisiteLinkUp !== 0) {
      writer.uint32(2696).uint32(message.assertConfigMultisiteLinkUp);
    }
    if (message.assertMultisiteLinkUp !== 0) {
      writer.uint32(2704).uint32(message.assertMultisiteLinkUp);
    }
    if (message.multisiteLink !== "") {
      writer.uint32(2722).string(message.multisiteLink);
    }
    if (message.twampSession !== 0) {
      writer.uint32(2728).uint32(message.twampSession);
    }
    if (message.assertConfigPortQsfpHealthy !== 0) {
      writer.uint32(2736).uint32(message.assertConfigPortQsfpHealthy);
    }
    if (message.assertPortQsfpHealthy !== 0) {
      writer.uint32(2744).uint32(message.assertPortQsfpHealthy);
    }
    if (message.assertConfigMultisiteLatencyStable !== 0) {
      writer.uint32(2752).uint32(message.assertConfigMultisiteLatencyStable);
    }
    if (message.assertMultisiteLatencyStable !== 0) {
      writer.uint32(2760).uint32(message.assertMultisiteLatencyStable);
    }
    if (message.l2FdbBucketedMultisite !== "") {
      writer.uint32(2778).string(message.l2FdbBucketedMultisite);
    }
    if (message.commandRequest !== "") {
      writer.uint32(2786).string(message.commandRequest);
    }
    if (message.commandOutput !== "") {
      writer.uint32(2794).string(message.commandOutput);
    }
    if (message.commandOutputRecord !== 0) {
      writer.uint32(2800).uint32(message.commandOutputRecord);
    }
    if (message.assertConfigMultisiteExpectedMtu !== 0) {
      writer.uint32(2808).uint32(message.assertConfigMultisiteExpectedMtu);
    }
    if (message.assertMultisiteExpectedMtu !== 0) {
      writer.uint32(2816).uint32(message.assertMultisiteExpectedMtu);
    }
    if (message.imageManifestInfo !== 0) {
      writer.uint32(2824).uint32(message.imageManifestInfo);
    }
    if (message.ipRouteFabricJoinedViewCountSpace !== "") {
      writer.uint32(2834).string(message.ipRouteFabricJoinedViewCountSpace);
    }
    if (message.ipRouteFabricJoinedViewCount !== 0) {
      writer.uint32(2840).uint32(message.ipRouteFabricJoinedViewCount);
    }
    if (message.borderPort !== 0) {
      writer.uint32(2848).uint32(message.borderPort);
    }
    if (message.networkInterfaceSummary !== "") {
      writer.uint32(2858).string(message.networkInterfaceSummary);
    }
    if (message.vrfEndpointCounts !== "") {
      writer.uint32(2866).string(message.vrfEndpointCounts);
    }
    if (message.assertConfigNxosDeviceExpectedFeatures !== 0) {
      writer.uint32(2872).uint32(message.assertConfigNxosDeviceExpectedFeatures);
    }
    if (message.assertNxosDeviceExpectedFeatures !== 0) {
      writer.uint32(2880).uint32(message.assertNxosDeviceExpectedFeatures);
    }
    if (message.opticsFirmwareUpdate !== 0) {
      writer.uint32(2888).uint32(message.opticsFirmwareUpdate);
    }
    if (message.arsConfig !== "") {
      writer.uint32(2898).string(message.arsConfig);
    }
    if (message.softwareUpdateStatus !== 0) {
      writer.uint32(2904).uint32(message.softwareUpdateStatus);
    }
    if (message.vxlanRemoteVtepInfo !== "") {
      writer.uint32(2914).string(message.vxlanRemoteVtepInfo);
    }
    if (message.arsInfo !== 0) {
      writer.uint32(2920).uint32(message.arsInfo);
    }
    if (message.cellPair !== "") {
      writer.uint32(2930).string(message.cellPair);
    }
    if (message.arsPortInfo !== 0) {
      writer.uint32(2936).uint32(message.arsPortInfo);
    }
    if (message.fabricRack !== "") {
      writer.uint32(2946).string(message.fabricRack);
    }
    if (message.iterativeSpiderClaim !== "") {
      writer.uint32(2954).string(message.iterativeSpiderClaim);
    }
    if (message.invalidUserSession !== "") {
      writer.uint32(2962).string(message.invalidUserSession);
    }
    if (message.systemHealth !== 0) {
      writer.uint32(2968).uint32(message.systemHealth);
    }
    if (message.portVlanAssertSummary !== "") {
      writer.uint32(2978).string(message.portVlanAssertSummary);
    }
    if (message.serverNetworkAdapter !== "") {
      writer.uint32(2986).string(message.serverNetworkAdapter);
    }
    if (message.bmcServerNetworkAdapter !== "") {
      writer.uint32(2994).string(message.bmcServerNetworkAdapter);
    }
    if (message.serverProcessor !== "") {
      writer.uint32(3002).string(message.serverProcessor);
    }
    if (message.bmcServerProcessor !== "") {
      writer.uint32(3010).string(message.bmcServerProcessor);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PathId {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePathId();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.deleted = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.pathString = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 24: {
          if (tag !== 194) {
            break;
          }

          message.fabric = reader.string();
          continue;
        }
        case 25: {
          if (tag !== 202) {
            break;
          }

          message.device = reader.string();
          continue;
        }
        case 26: {
          if (tag !== 208) {
            break;
          }

          message.fan = reader.uint32();
          continue;
        }
        case 27: {
          if (tag !== 216) {
            break;
          }

          message.psu = reader.uint32();
          continue;
        }
        case 28: {
          if (tag !== 224) {
            break;
          }

          message.tempSensor = reader.uint32();
          continue;
        }
        case 29: {
          if (tag !== 232) {
            break;
          }

          message.lineCard = reader.uint32();
          continue;
        }
        case 30: {
          if (tag !== 240) {
            break;
          }

          message.port = reader.uint32();
          continue;
        }
        case 31: {
          if (tag !== 248) {
            break;
          }

          message.dacQsfp = reader.uint32();
          continue;
        }
        case 32: {
          if (tag !== 256) {
            break;
          }

          message.fiberQsfp = reader.uint32();
          continue;
        }
        case 33: {
          if (tag !== 264) {
            break;
          }

          message.breakout = reader.uint32();
          continue;
        }
        case 34: {
          if (tag !== 274) {
            break;
          }

          message.portNeighbor = reader.string();
          continue;
        }
        case 35: {
          if (tag !== 280) {
            break;
          }

          message.vtep = reader.uint32();
          continue;
        }
        case 36: {
          if (tag !== 288) {
            break;
          }

          message.vniPort = reader.uint32();
          continue;
        }
        case 37: {
          if (tag !== 296) {
            break;
          }

          message.mac = reader.uint32();
          continue;
        }
        case 38: {
          if (tag !== 304) {
            break;
          }

          message.procTable = reader.uint32();
          continue;
        }
        case 39: {
          if (tag !== 314) {
            break;
          }

          message.portVlan = reader.string();
          continue;
        }
        case 40: {
          if (tag !== 320) {
            break;
          }

          message.vlanState = reader.uint32();
          continue;
        }
        case 42: {
          if (tag !== 336) {
            break;
          }

          message.qsfpDomSensor = reader.uint32();
          continue;
        }
        case 47: {
          if (tag !== 376) {
            break;
          }

          message.portConfig = reader.uint32();
          continue;
        }
        case 48: {
          if (tag !== 384) {
            break;
          }

          message.nodeConfig = reader.uint32();
          continue;
        }
        case 49: {
          if (tag !== 394) {
            break;
          }

          message.fabricConfig = reader.string();
          continue;
        }
        case 50: {
          if (tag !== 400) {
            break;
          }

          message.fabricConfigEvent = reader.uint32();
          continue;
        }
        case 51: {
          if (tag !== 408) {
            break;
          }

          message.l2Fdb = reader.uint32();
          continue;
        }
        case 52: {
          if (tag !== 416) {
            break;
          }

          message.portCounters = reader.uint32();
          continue;
        }
        case 53: {
          if (tag !== 426) {
            break;
          }

          message.remedyAction = reader.string();
          continue;
        }
        case 54: {
          if (tag !== 432) {
            break;
          }

          message.qsfpInfo = reader.uint32();
          continue;
        }
        case 55: {
          if (tag !== 442) {
            break;
          }

          message.fabricDevice = reader.string();
          continue;
        }
        case 56: {
          if (tag !== 448) {
            break;
          }

          message.assertConfigPortLinkUp = reader.uint32();
          continue;
        }
        case 57: {
          if (tag !== 456) {
            break;
          }

          message.assertPortLinkUp = reader.uint32();
          continue;
        }
        case 58: {
          if (tag !== 464) {
            break;
          }

          message.assertConfigDeviceConnectedToCloud = reader.uint32();
          continue;
        }
        case 59: {
          if (tag !== 472) {
            break;
          }

          message.assertDeviceConnectedToCloud = reader.uint32();
          continue;
        }
        case 60: {
          if (tag !== 480) {
            break;
          }

          message.assertConfigPortExpectedNeighbor = reader.uint32();
          continue;
        }
        case 61: {
          if (tag !== 488) {
            break;
          }

          message.assertPortExpectedNeighbor = reader.uint32();
          continue;
        }
        case 62: {
          if (tag !== 496) {
            break;
          }

          message.assertConfigPortNotConnectedToFabric = reader.uint32();
          continue;
        }
        case 63: {
          if (tag !== 504) {
            break;
          }

          message.assertPortNotConnectedToFabric = reader.uint32();
          continue;
        }
        case 64: {
          if (tag !== 512) {
            break;
          }

          message.assertConfigDeviceConnectedToFabric = reader.uint32();
          continue;
        }
        case 65: {
          if (tag !== 520) {
            break;
          }

          message.assertDeviceConnectedToFabric = reader.uint32();
          continue;
        }
        case 66: {
          if (tag !== 528) {
            break;
          }

          message.assertConfigPortLinkDown = reader.uint32();
          continue;
        }
        case 67: {
          if (tag !== 536) {
            break;
          }

          message.assertPortLinkDown = reader.uint32();
          continue;
        }
        case 68: {
          if (tag !== 544) {
            break;
          }

          message.assertConfigPortConnectionSpeedMatch = reader.uint32();
          continue;
        }
        case 69: {
          if (tag !== 552) {
            break;
          }

          message.assertPortConnectionSpeedMatch = reader.uint32();
          continue;
        }
        case 70: {
          if (tag !== 560) {
            break;
          }

          message.assertConfigPortSpeedConsistent = reader.uint32();
          continue;
        }
        case 71: {
          if (tag !== 568) {
            break;
          }

          message.assertPortSpeedConsistent = reader.uint32();
          continue;
        }
        case 73: {
          if (tag !== 584) {
            break;
          }

          message.underlayInfo = reader.uint32();
          continue;
        }
        case 74: {
          if (tag !== 592) {
            break;
          }

          message.proxyStats = reader.uint32();
          continue;
        }
        case 75: {
          if (tag !== 600) {
            break;
          }

          message.vlanCounters = reader.uint32();
          continue;
        }
        case 76: {
          if (tag !== 608) {
            break;
          }

          message.testPlaceHolder1Secret = reader.uint32();
          continue;
        }
        case 77: {
          if (tag !== 616) {
            break;
          }

          message.assertConfigVlanHasTraffic = reader.uint32();
          continue;
        }
        case 78: {
          if (tag !== 624) {
            break;
          }

          message.assertVlanHasTraffic = reader.uint32();
          continue;
        }
        case 79: {
          if (tag !== 632) {
            break;
          }

          message.remoteVtep = reader.uint32();
          continue;
        }
        case 80: {
          if (tag !== 640) {
            break;
          }

          message.qsfpDomThreshold = reader.uint32();
          continue;
        }
        case 82: {
          if (tag !== 658) {
            break;
          }

          message.l3Table = reader.string();
          continue;
        }
        case 83: {
          if (tag !== 664) {
            break;
          }

          message.vlanVniMap = reader.uint32();
          continue;
        }
        case 84: {
          if (tag !== 674) {
            break;
          }

          message.proxyConnectionState = reader.string();
          continue;
        }
        case 85: {
          if (tag !== 680) {
            break;
          }

          message.proxyConnectionStats = reader.uint32();
          continue;
        }
        case 86: {
          if (tag !== 690) {
            break;
          }

          message.l2Mac = reader.string();
          continue;
        }
        case 87: {
          if (tag !== 696) {
            break;
          }

          message.bmc = reader.uint32();
          continue;
        }
        case 91: {
          if (tag !== 730) {
            break;
          }

          message.ipRouteTable = reader.string();
          continue;
        }
        case 92: {
          if (tag !== 738) {
            break;
          }

          message.vrf = reader.string();
          continue;
        }
        case 93: {
          if (tag !== 744) {
            break;
          }

          message.ipNextHop = reader.uint32();
          continue;
        }
        case 94: {
          if (tag !== 754) {
            break;
          }

          message.ipPrefix = reader.string();
          continue;
        }
        case 95: {
          if (tag !== 760) {
            break;
          }

          message.subInterface = reader.uint32();
          continue;
        }
        case 96: {
          if (tag !== 768) {
            break;
          }

          message.assertConfigStaticDefaultRouteExists = reader.uint32();
          continue;
        }
        case 97: {
          if (tag !== 776) {
            break;
          }

          message.assertStaticDefaultRouteExists = reader.uint32();
          continue;
        }
        case 98: {
          if (tag !== 786) {
            break;
          }

          message.spyglassBrokerEntry = reader.string();
          continue;
        }
        case 99: {
          if (tag !== 794) {
            break;
          }

          message.managementState = reader.string();
          continue;
        }
        case 102: {
          if (tag !== 816) {
            break;
          }

          message.assertConfigManagementPortConfigSame = reader.uint32();
          continue;
        }
        case 103: {
          if (tag !== 824) {
            break;
          }

          message.assertManagementPortConfigSame = reader.uint32();
          continue;
        }
        case 104: {
          if (tag !== 832) {
            break;
          }

          message.fabricConfigNotification = reader.uint32();
          continue;
        }
        case 105: {
          if (tag !== 840) {
            break;
          }

          message.spyglassGingerEntry = reader.uint32();
          continue;
        }
        case 106: {
          if (tag !== 848) {
            break;
          }

          message.plannedConfig = reader.uint32();
          continue;
        }
        case 107: {
          if (tag !== 856) {
            break;
          }

          message.routedInterfaceCounters = reader.uint32();
          continue;
        }
        case 108: {
          if (tag !== 864) {
            break;
          }

          message.ipmRawLatencyCounters = reader.uint32();
          continue;
        }
        case 109: {
          if (tag !== 872) {
            break;
          }

          message.ipmProcLatencyCounters = reader.uint32();
          continue;
        }
        case 110: {
          if (tag !== 880) {
            break;
          }

          message.ipmProcLossCounters = reader.uint32();
          continue;
        }
        case 111: {
          if (tag !== 888) {
            break;
          }

          message.ipmLivenessCounters = reader.uint32();
          continue;
        }
        case 112: {
          if (tag !== 898) {
            break;
          }

          message.ipmSessionId = reader.string();
          continue;
        }
        case 113: {
          if (tag !== 904) {
            break;
          }

          message.ipmProcJitterCounters = reader.uint32();
          continue;
        }
        case 119: {
          if (tag !== 952) {
            break;
          }

          message.systemStats = reader.uint32();
          continue;
        }
        case 120: {
          if (tag !== 962) {
            break;
          }

          message.testRootOne = reader.string();
          continue;
        }
        case 121: {
          if (tag !== 970) {
            break;
          }

          message.testRootTwo = reader.string();
          continue;
        }
        case 122: {
          if (tag !== 976) {
            break;
          }

          message.testMidOne = reader.uint32();
          continue;
        }
        case 124: {
          if (tag !== 994) {
            break;
          }

          message.testLeafOne = reader.string();
          continue;
        }
        case 126: {
          if (tag !== 1010) {
            break;
          }

          message.testIpAddress = reader.string();
          continue;
        }
        case 127: {
          if (tag !== 1018) {
            break;
          }

          message.testIpPrefix = reader.string();
          continue;
        }
        case 128: {
          if (tag !== 1026) {
            break;
          }

          message.testMacAddress = reader.string();
          continue;
        }
        case 129: {
          if (tag !== 1032) {
            break;
          }

          message.assertConfigDeviceResourceUsageBelowThreshold = reader.uint32();
          continue;
        }
        case 130: {
          if (tag !== 1040) {
            break;
          }

          message.assertDeviceResourceUsageBelowThreshold = reader.uint32();
          continue;
        }
        case 131: {
          if (tag !== 1048) {
            break;
          }

          message.fabricTransaction = reader.int64().toString();
          continue;
        }
        case 133: {
          if (tag !== 1066) {
            break;
          }

          message.bgpNeighborSummary = reader.string();
          continue;
        }
        case 135: {
          if (tag !== 1080) {
            break;
          }

          message.deviceConnection = reader.uint32();
          continue;
        }
        case 136: {
          if (tag !== 1088) {
            break;
          }

          message.bgpNeighborFamily = reader.uint32();
          continue;
        }
        case 137: {
          if (tag !== 1096) {
            break;
          }

          message.assertConfigBgpPeerEstablished = reader.uint32();
          continue;
        }
        case 138: {
          if (tag !== 1104) {
            break;
          }

          message.assertBgpPeerEstablished = reader.uint32();
          continue;
        }
        case 139: {
          if (tag !== 1112) {
            break;
          }

          message.spyglassSshSessionEntry = reader.uint32();
          continue;
        }
        case 140: {
          if (tag !== 1122) {
            break;
          }

          message.portChannelMemberState = reader.string();
          continue;
        }
        case 141: {
          if (tag !== 1130) {
            break;
          }

          message.portChannelState = reader.string();
          continue;
        }
        case 146: {
          if (tag !== 1170) {
            break;
          }

          message.spyglassDevice = reader.string();
          continue;
        }
        case 147: {
          if (tag !== 1176) {
            break;
          }

          message.spyglassTcpListener = reader.uint32();
          continue;
        }
        case 148: {
          if (tag !== 1184) {
            break;
          }

          message.spyglassTcpSession = reader.uint32();
          continue;
        }
        case 149: {
          if (tag !== 1192) {
            break;
          }

          message.unknownVlan = reader.uint32();
          continue;
        }
        case 150: {
          if (tag !== 1202) {
            break;
          }

          message.unknownVlanPort = reader.string();
          continue;
        }
        case 151: {
          if (tag !== 1208) {
            break;
          }

          message.assertConfigExpectedPortBreakoutExists = reader.uint32();
          continue;
        }
        case 152: {
          if (tag !== 1216) {
            break;
          }

          message.assertExpectedPortBreakoutExists = reader.uint32();
          continue;
        }
        case 153: {
          if (tag !== 1224) {
            break;
          }

          message.assertConfigSubInterfaceUp = reader.uint32();
          continue;
        }
        case 154: {
          if (tag !== 1232) {
            break;
          }

          message.assertSubInterfaceUp = reader.uint32();
          continue;
        }
        case 155: {
          if (tag !== 1240) {
            break;
          }

          message.assertSubInterfaceDown = reader.uint32();
          continue;
        }
        case 156: {
          if (tag !== 1248) {
            break;
          }

          message.assertConfigSubInterfaceDown = reader.uint32();
          continue;
        }
        case 158: {
          if (tag !== 1264) {
            break;
          }

          message.deviceClaim = reader.uint32();
          continue;
        }
        case 159: {
          if (tag !== 1274) {
            break;
          }

          message.aggregatedDeviceClaim = reader.string();
          continue;
        }
        case 160: {
          if (tag !== 1280) {
            break;
          }

          message.assertPortChannelMemberUp = reader.uint32();
          continue;
        }
        case 161: {
          if (tag !== 1288) {
            break;
          }

          message.assertConfigPortChannelMemberUp = reader.uint32();
          continue;
        }
        case 162: {
          if (tag !== 1298) {
            break;
          }

          message.esiInfo = reader.string();
          continue;
        }
        case 163: {
          if (tag !== 1306) {
            break;
          }

          message.esiVtepInfo = reader.string();
          continue;
        }
        case 164: {
          if (tag !== 1312) {
            break;
          }

          message.assertPortVlanStpStateConsistent = reader.uint32();
          continue;
        }
        case 165: {
          if (tag !== 1320) {
            break;
          }

          message.assertConfigPortVlanStpStateConsistent = reader.uint32();
          continue;
        }
        case 166: {
          if (tag !== 1328) {
            break;
          }

          message.assertPortPluggablePidSame = reader.uint32();
          continue;
        }
        case 167: {
          if (tag !== 1336) {
            break;
          }

          message.assertConfigPortPluggablePidSame = reader.uint32();
          continue;
        }
        case 170: {
          if (tag !== 1360) {
            break;
          }

          message.manifestImageState = reader.uint32();
          continue;
        }
        case 171: {
          if (tag !== 1368) {
            break;
          }

          message.portRateCounters = reader.uint32();
          continue;
        }
        case 172: {
          if (tag !== 1378) {
            break;
          }

          message.authorizedUserEntry = reader.string();
          continue;
        }
        case 173: {
          if (tag !== 1386) {
            break;
          }

          message.delegatedReadOnlyUserEntry = reader.string();
          continue;
        }
        case 220: {
          if (tag !== 1762) {
            break;
          }

          message.orgUuid = reader.string();
          continue;
        }
        case 221: {
          if (tag !== 1770) {
            break;
          }

          message.fabricUuid = reader.string();
          continue;
        }
        case 225: {
          if (tag !== 1802) {
            break;
          }

          message.apiPath = reader.string();
          continue;
        }
        case 226: {
          if (tag !== 1810) {
            break;
          }

          message.apiPathMethod = reader.string();
          continue;
        }
        case 227: {
          if (tag !== 1816) {
            break;
          }

          message.apiServiceMapping = reader.uint32();
          continue;
        }
        case 228: {
          if (tag !== 1824) {
            break;
          }

          message.orgToCellPairMapping = reader.uint32();
          continue;
        }
        case 229: {
          if (tag !== 1834) {
            break;
          }

          message.tenantUuid = reader.string();
          continue;
        }
        case 230: {
          if (tag !== 1842) {
            break;
          }

          message.userEmail = reader.string();
          continue;
        }
        case 231: {
          if (tag !== 1848) {
            break;
          }

          message.managementConfig = reader.uint32();
          continue;
        }
        case 232: {
          if (tag !== 1858) {
            break;
          }

          message.serviceInstanceHealth = reader.string();
          continue;
        }
        case 233: {
          if (tag !== 1866) {
            break;
          }

          message.assignmentStatus = reader.string();
          continue;
        }
        case 235: {
          if (tag !== 1882) {
            break;
          }

          message.kubernetesServiceInstance = reader.string();
          continue;
        }
        case 242: {
          if (tag !== 1938) {
            break;
          }

          message.bearerToken = reader.string();
          continue;
        }
        case 243: {
          if (tag !== 1946) {
            break;
          }

          message.apiKey = reader.string();
          continue;
        }
        case 244: {
          if (tag !== 1954) {
            break;
          }

          message.fabricMemoryUsage = reader.string();
          continue;
        }
        case 245: {
          if (tag !== 1960) {
            break;
          }

          message.typeMemoryUsage = reader.uint32();
          continue;
        }
        case 246: {
          if (tag !== 1968) {
            break;
          }

          message.manifestRunningImageStatus = reader.uint32();
          continue;
        }
        case 247: {
          if (tag !== 1978) {
            break;
          }

          message.manifestPartitionFileCacheStatus = reader.string();
          continue;
        }
        case 248: {
          if (tag !== 1986) {
            break;
          }

          message.stpPortState = reader.string();
          continue;
        }
        case 249: {
          if (tag !== 1992) {
            break;
          }

          message.stpVlanState = reader.uint32();
          continue;
        }
        case 250: {
          if (tag !== 2002) {
            break;
          }

          message.stpVlanPortState = reader.string();
          continue;
        }
        case 258: {
          if (tag !== 2064) {
            break;
          }

          message.unpackAndAssembleTask = reader.uint32();
          continue;
        }
        case 260: {
          if (tag !== 2080) {
            break;
          }

          message.claimAndBindTask = reader.uint32();
          continue;
        }
        case 261: {
          if (tag !== 2088) {
            break;
          }

          message.portSetupTask = reader.uint32();
          continue;
        }
        case 262: {
          if (tag !== 2096) {
            break;
          }

          message.fabricConnectionTask = reader.uint32();
          continue;
        }
        case 263: {
          if (tag !== 2104) {
            break;
          }

          message.negativeConnectionTask = reader.uint32();
          continue;
        }
        case 264: {
          if (tag !== 2112) {
            break;
          }

          message.application = reader.uint32();
          continue;
        }
        case 265: {
          if (tag !== 2122) {
            break;
          }

          message.resourceAssignment = reader.string();
          continue;
        }
        case 266: {
          if (tag !== 2130) {
            break;
          }

          message.node = reader.string();
          continue;
        }
        case 267: {
          if (tag !== 2136) {
            break;
          }

          message.nodeLineCard = reader.uint32();
          continue;
        }
        case 268: {
          if (tag !== 2144) {
            break;
          }

          message.nodePort = reader.uint32();
          continue;
        }
        case 269: {
          if (tag !== 2152) {
            break;
          }

          message.nodeBreakout = reader.uint32();
          continue;
        }
        case 270: {
          if (tag !== 2160) {
            break;
          }

          message.tenantMetadata = reader.uint32();
          continue;
        }
        case 271: {
          if (tag !== 2168) {
            break;
          }

          message.assertPortNoUnknownVlanFound = reader.uint32();
          continue;
        }
        case 272: {
          if (tag !== 2176) {
            break;
          }

          message.assertConfigPortNoUnknownVlanFound = reader.uint32();
          continue;
        }
        case 273: {
          if (tag !== 2186) {
            break;
          }

          message.bulkUpliftJobRequest = reader.string();
          continue;
        }
        case 274: {
          if (tag !== 2194) {
            break;
          }

          message.bulkUpliftJobStatus = reader.string();
          continue;
        }
        case 275: {
          if (tag !== 2202) {
            break;
          }

          message.bgpNeighborInfo = reader.string();
          continue;
        }
        case 276: {
          if (tag !== 2210) {
            break;
          }

          message.refPoint = reader.string();
          continue;
        }
        case 277: {
          if (tag !== 2218) {
            break;
          }

          message.refPointStatus = reader.string();
          continue;
        }
        case 278: {
          if (tag !== 2226) {
            break;
          }

          message.userPreferenceItem = reader.string();
          continue;
        }
        case 279: {
          if (tag !== 2234) {
            break;
          }

          message.bgpNeighborReceivedRoute = reader.string();
          continue;
        }
        case 280: {
          if (tag !== 2242) {
            break;
          }

          message.userEula = reader.string();
          continue;
        }
        case 281: {
          if (tag !== 2248) {
            break;
          }

          message.brigSymmetricSigningKey = reader.uint32();
          continue;
        }
        case 282: {
          if (tag !== 2256) {
            break;
          }

          message.firmwareVersion = reader.uint32();
          continue;
        }
        case 283: {
          if (tag !== 2266) {
            break;
          }

          message.serverIpRouteAddress = reader.string();
          continue;
        }
        case 284: {
          if (tag !== 2274) {
            break;
          }

          message.serverIpRouteTable = reader.string();
          continue;
        }
        case 285: {
          if (tag !== 2280) {
            break;
          }

          message.apiPathProtocol = reader.uint32();
          continue;
        }
        case 286: {
          if (tag !== 2290) {
            break;
          }

          message.serverPsu = reader.string();
          continue;
        }
        case 287: {
          if (tag !== 2296) {
            break;
          }

          message.serverTempSensor = reader.uint32();
          continue;
        }
        case 288: {
          if (tag !== 2304) {
            break;
          }

          message.loadBalancedSvcRoute = reader.uint32();
          continue;
        }
        case 289: {
          if (tag !== 2314) {
            break;
          }

          message.assignmentSvcRoute = reader.string();
          continue;
        }
        case 290: {
          if (tag !== 2320) {
            break;
          }

          message.dbTableUpdateNotification = reader.uint32();
          continue;
        }
        case 291: {
          if (tag !== 2328) {
            break;
          }

          message.assertDeviceFanSpeedBelowThreshold = reader.uint32();
          continue;
        }
        case 292: {
          if (tag !== 2336) {
            break;
          }

          message.assertConfigDeviceFanSpeedBelowThreshold = reader.uint32();
          continue;
        }
        case 293: {
          if (tag !== 2344) {
            break;
          }

          message.assertDeviceTemperatureBelowThreshold = reader.uint32();
          continue;
        }
        case 294: {
          if (tag !== 2352) {
            break;
          }

          message.assertConfigDeviceTemperatureBelowThreshold = reader.uint32();
          continue;
        }
        case 295: {
          if (tag !== 2362) {
            break;
          }

          message.activeWorker = reader.string();
          continue;
        }
        case 296: {
          if (tag !== 2368) {
            break;
          }

          message.serverFan = reader.uint32();
          continue;
        }
        case 297: {
          if (tag !== 2376) {
            break;
          }

          message.serverPortInfo = reader.uint32();
          continue;
        }
        case 298: {
          if (tag !== 2384) {
            break;
          }

          message.assertDevicePsuUsageBelowThreshold = reader.uint32();
          continue;
        }
        case 299: {
          if (tag !== 2392) {
            break;
          }

          message.assertConfigDevicePsuUsageBelowThreshold = reader.uint32();
          continue;
        }
        case 300: {
          if (tag !== 2402) {
            break;
          }

          message.bmcServer = reader.string();
          continue;
        }
        case 301: {
          if (tag !== 2410) {
            break;
          }

          message.bmcServerPsu = reader.string();
          continue;
        }
        case 302: {
          if (tag !== 2416) {
            break;
          }

          message.bmcServerTempSensor = reader.uint32();
          continue;
        }
        case 303: {
          if (tag !== 2424) {
            break;
          }

          message.bmcServerFan = reader.uint32();
          continue;
        }
        case 304: {
          if (tag !== 2432) {
            break;
          }

          message.bmcServerPortInfo = reader.uint32();
          continue;
        }
        case 305: {
          if (tag !== 2440) {
            break;
          }

          message.ipRouteJoinedView = reader.uint32();
          continue;
        }
        case 306: {
          if (tag !== 2448) {
            break;
          }

          message.serverToBmc = reader.uint32();
          continue;
        }
        case 307: {
          if (tag !== 2458) {
            break;
          }

          message.serverMac = reader.string();
          continue;
        }
        case 308: {
          if (tag !== 2466) {
            break;
          }

          message.serverInterface = reader.string();
          continue;
        }
        case 309: {
          if (tag !== 2474) {
            break;
          }

          message.serverL3Table = reader.string();
          continue;
        }
        case 310: {
          if (tag !== 2482) {
            break;
          }

          message.serverInterfaceInfo = reader.string();
          continue;
        }
        case 312: {
          if (tag !== 2496) {
            break;
          }

          message.pluggableConnectionInfo = reader.uint32();
          continue;
        }
        case 313: {
          if (tag !== 2506) {
            break;
          }

          message.ipRouteJoinedViewCountSpace = reader.string();
          continue;
        }
        case 314: {
          if (tag !== 2512) {
            break;
          }

          message.ipRouteJoinedViewCount = reader.uint32();
          continue;
        }
        case 315: {
          if (tag !== 2522) {
            break;
          }

          message.l2FdbBucketed = reader.string();
          continue;
        }
        case 316: {
          if (tag !== 2530) {
            break;
          }

          message.l2FdbSingle = reader.string();
          continue;
        }
        case 317: {
          if (tag !== 2536) {
            break;
          }

          message.l2FdbSingleVlan = reader.uint32();
          continue;
        }
        case 318: {
          if (tag !== 2546) {
            break;
          }

          message.signingKey = reader.string();
          continue;
        }
        case 319: {
          if (tag !== 2554) {
            break;
          }

          message.bgpNeighborAdvertisedRoute = reader.string();
          continue;
        }
        case 320: {
          if (tag !== 2560) {
            break;
          }

          message.serverInterfaceMapping = reader.uint32();
          continue;
        }
        case 321: {
          if (tag !== 2568) {
            break;
          }

          message.signingKeyFlavor = reader.uint32();
          continue;
        }
        case 322: {
          if (tag !== 2578) {
            break;
          }

          message.ipSlaProbe = reader.string();
          continue;
        }
        case 323: {
          if (tag !== 2586) {
            break;
          }

          message.staticRoute = reader.string();
          continue;
        }
        case 324: {
          if (tag !== 2594) {
            break;
          }

          message.interconnect = reader.string();
          continue;
        }
        case 325: {
          if (tag !== 2600) {
            break;
          }

          message.interconnectTransaction = reader.int64().toString();
          continue;
        }
        case 326: {
          if (tag !== 2608) {
            break;
          }

          message.orgMetadata = reader.uint32();
          continue;
        }
        case 327: {
          if (tag !== 2618) {
            break;
          }

          message.fabricInterconnectConfig = reader.string();
          continue;
        }
        case 328: {
          if (tag !== 2626) {
            break;
          }

          message.spanSession = reader.string();
          continue;
        }
        case 329: {
          if (tag !== 2632) {
            break;
          }

          message.portVlanInfo = reader.uint32();
          continue;
        }
        case 331: {
          if (tag !== 2648) {
            break;
          }

          message.bgpRouteStats = reader.uint32();
          continue;
        }
        case 332: {
          if (tag !== 2656) {
            break;
          }

          message.vniMacCounts = reader.uint32();
          continue;
        }
        case 333: {
          if (tag !== 2664) {
            break;
          }

          message.gpuDevice = reader.uint32();
          continue;
        }
        case 334: {
          if (tag !== 2674) {
            break;
          }

          message.vxlanTunnel = reader.string();
          continue;
        }
        case 335: {
          if (tag !== 2682) {
            break;
          }

          message.vxlanTunnelMapping = reader.string();
          continue;
        }
        case 336: {
          if (tag !== 2690) {
            break;
          }

          message.vxlanRemoteVtepMapping = reader.string();
          continue;
        }
        case 337: {
          if (tag !== 2696) {
            break;
          }

          message.assertConfigMultisiteLinkUp = reader.uint32();
          continue;
        }
        case 338: {
          if (tag !== 2704) {
            break;
          }

          message.assertMultisiteLinkUp = reader.uint32();
          continue;
        }
        case 340: {
          if (tag !== 2722) {
            break;
          }

          message.multisiteLink = reader.string();
          continue;
        }
        case 341: {
          if (tag !== 2728) {
            break;
          }

          message.twampSession = reader.uint32();
          continue;
        }
        case 342: {
          if (tag !== 2736) {
            break;
          }

          message.assertConfigPortQsfpHealthy = reader.uint32();
          continue;
        }
        case 343: {
          if (tag !== 2744) {
            break;
          }

          message.assertPortQsfpHealthy = reader.uint32();
          continue;
        }
        case 344: {
          if (tag !== 2752) {
            break;
          }

          message.assertConfigMultisiteLatencyStable = reader.uint32();
          continue;
        }
        case 345: {
          if (tag !== 2760) {
            break;
          }

          message.assertMultisiteLatencyStable = reader.uint32();
          continue;
        }
        case 347: {
          if (tag !== 2778) {
            break;
          }

          message.l2FdbBucketedMultisite = reader.string();
          continue;
        }
        case 348: {
          if (tag !== 2786) {
            break;
          }

          message.commandRequest = reader.string();
          continue;
        }
        case 349: {
          if (tag !== 2794) {
            break;
          }

          message.commandOutput = reader.string();
          continue;
        }
        case 350: {
          if (tag !== 2800) {
            break;
          }

          message.commandOutputRecord = reader.uint32();
          continue;
        }
        case 351: {
          if (tag !== 2808) {
            break;
          }

          message.assertConfigMultisiteExpectedMtu = reader.uint32();
          continue;
        }
        case 352: {
          if (tag !== 2816) {
            break;
          }

          message.assertMultisiteExpectedMtu = reader.uint32();
          continue;
        }
        case 353: {
          if (tag !== 2824) {
            break;
          }

          message.imageManifestInfo = reader.uint32();
          continue;
        }
        case 354: {
          if (tag !== 2834) {
            break;
          }

          message.ipRouteFabricJoinedViewCountSpace = reader.string();
          continue;
        }
        case 355: {
          if (tag !== 2840) {
            break;
          }

          message.ipRouteFabricJoinedViewCount = reader.uint32();
          continue;
        }
        case 356: {
          if (tag !== 2848) {
            break;
          }

          message.borderPort = reader.uint32();
          continue;
        }
        case 357: {
          if (tag !== 2858) {
            break;
          }

          message.networkInterfaceSummary = reader.string();
          continue;
        }
        case 358: {
          if (tag !== 2866) {
            break;
          }

          message.vrfEndpointCounts = reader.string();
          continue;
        }
        case 359: {
          if (tag !== 2872) {
            break;
          }

          message.assertConfigNxosDeviceExpectedFeatures = reader.uint32();
          continue;
        }
        case 360: {
          if (tag !== 2880) {
            break;
          }

          message.assertNxosDeviceExpectedFeatures = reader.uint32();
          continue;
        }
        case 361: {
          if (tag !== 2888) {
            break;
          }

          message.opticsFirmwareUpdate = reader.uint32();
          continue;
        }
        case 362: {
          if (tag !== 2898) {
            break;
          }

          message.arsConfig = reader.string();
          continue;
        }
        case 363: {
          if (tag !== 2904) {
            break;
          }

          message.softwareUpdateStatus = reader.uint32();
          continue;
        }
        case 364: {
          if (tag !== 2914) {
            break;
          }

          message.vxlanRemoteVtepInfo = reader.string();
          continue;
        }
        case 365: {
          if (tag !== 2920) {
            break;
          }

          message.arsInfo = reader.uint32();
          continue;
        }
        case 366: {
          if (tag !== 2930) {
            break;
          }

          message.cellPair = reader.string();
          continue;
        }
        case 367: {
          if (tag !== 2936) {
            break;
          }

          message.arsPortInfo = reader.uint32();
          continue;
        }
        case 368: {
          if (tag !== 2946) {
            break;
          }

          message.fabricRack = reader.string();
          continue;
        }
        case 369: {
          if (tag !== 2954) {
            break;
          }

          message.iterativeSpiderClaim = reader.string();
          continue;
        }
        case 370: {
          if (tag !== 2962) {
            break;
          }

          message.invalidUserSession = reader.string();
          continue;
        }
        case 371: {
          if (tag !== 2968) {
            break;
          }

          message.systemHealth = reader.uint32();
          continue;
        }
        case 372: {
          if (tag !== 2978) {
            break;
          }

          message.portVlanAssertSummary = reader.string();
          continue;
        }
        case 373: {
          if (tag !== 2986) {
            break;
          }

          message.serverNetworkAdapter = reader.string();
          continue;
        }
        case 374: {
          if (tag !== 2994) {
            break;
          }

          message.bmcServerNetworkAdapter = reader.string();
          continue;
        }
        case 375: {
          if (tag !== 3002) {
            break;
          }

          message.serverProcessor = reader.string();
          continue;
        }
        case 376: {
          if (tag !== 3010) {
            break;
          }

          message.bmcServerProcessor = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PathId {
    return {
      deleted: isSet(object.deleted) ? globalThis.Boolean(object.deleted) : false,
      pathString: isSet(object.pathString) ? globalThis.String(object.pathString) : "",
      type: isSet(object.type) ? schemaTypeFromJSON(object.type) : 0,
      fabric: isSet(object.fabric) ? globalThis.String(object.fabric) : "",
      device: isSet(object.device) ? globalThis.String(object.device) : "",
      fan: isSet(object.fan) ? globalThis.Number(object.fan) : 0,
      psu: isSet(object.psu) ? globalThis.Number(object.psu) : 0,
      tempSensor: isSet(object.tempSensor) ? globalThis.Number(object.tempSensor) : 0,
      lineCard: isSet(object.lineCard) ? globalThis.Number(object.lineCard) : 0,
      port: isSet(object.port) ? globalThis.Number(object.port) : 0,
      dacQsfp: isSet(object.dacQsfp) ? globalThis.Number(object.dacQsfp) : 0,
      fiberQsfp: isSet(object.fiberQsfp) ? globalThis.Number(object.fiberQsfp) : 0,
      breakout: isSet(object.breakout) ? globalThis.Number(object.breakout) : 0,
      portNeighbor: isSet(object.portNeighbor) ? globalThis.String(object.portNeighbor) : "",
      vtep: isSet(object.vtep) ? globalThis.Number(object.vtep) : 0,
      vniPort: isSet(object.vniPort) ? globalThis.Number(object.vniPort) : 0,
      mac: isSet(object.mac) ? globalThis.Number(object.mac) : 0,
      procTable: isSet(object.procTable) ? globalThis.Number(object.procTable) : 0,
      portVlan: isSet(object.portVlan) ? globalThis.String(object.portVlan) : "",
      vlanState: isSet(object.vlanState) ? globalThis.Number(object.vlanState) : 0,
      qsfpDomSensor: isSet(object.qsfpDomSensor) ? globalThis.Number(object.qsfpDomSensor) : 0,
      portConfig: isSet(object.portConfig) ? globalThis.Number(object.portConfig) : 0,
      nodeConfig: isSet(object.nodeConfig) ? globalThis.Number(object.nodeConfig) : 0,
      fabricConfig: isSet(object.fabricConfig) ? globalThis.String(object.fabricConfig) : "",
      fabricConfigEvent: isSet(object.fabricConfigEvent) ? globalThis.Number(object.fabricConfigEvent) : 0,
      l2Fdb: isSet(object.l2Fdb) ? globalThis.Number(object.l2Fdb) : 0,
      portCounters: isSet(object.portCounters) ? globalThis.Number(object.portCounters) : 0,
      remedyAction: isSet(object.remedyAction) ? globalThis.String(object.remedyAction) : "",
      qsfpInfo: isSet(object.qsfpInfo) ? globalThis.Number(object.qsfpInfo) : 0,
      fabricDevice: isSet(object.fabricDevice) ? globalThis.String(object.fabricDevice) : "",
      assertConfigPortLinkUp: isSet(object.assertConfigPortLinkUp)
        ? globalThis.Number(object.assertConfigPortLinkUp)
        : 0,
      assertPortLinkUp: isSet(object.assertPortLinkUp) ? globalThis.Number(object.assertPortLinkUp) : 0,
      assertConfigDeviceConnectedToCloud: isSet(object.assertConfigDeviceConnectedToCloud)
        ? globalThis.Number(object.assertConfigDeviceConnectedToCloud)
        : 0,
      assertDeviceConnectedToCloud: isSet(object.assertDeviceConnectedToCloud)
        ? globalThis.Number(object.assertDeviceConnectedToCloud)
        : 0,
      assertConfigPortExpectedNeighbor: isSet(object.assertConfigPortExpectedNeighbor)
        ? globalThis.Number(object.assertConfigPortExpectedNeighbor)
        : 0,
      assertPortExpectedNeighbor: isSet(object.assertPortExpectedNeighbor)
        ? globalThis.Number(object.assertPortExpectedNeighbor)
        : 0,
      assertConfigPortNotConnectedToFabric: isSet(object.assertConfigPortNotConnectedToFabric)
        ? globalThis.Number(object.assertConfigPortNotConnectedToFabric)
        : 0,
      assertPortNotConnectedToFabric: isSet(object.assertPortNotConnectedToFabric)
        ? globalThis.Number(object.assertPortNotConnectedToFabric)
        : 0,
      assertConfigDeviceConnectedToFabric: isSet(object.assertConfigDeviceConnectedToFabric)
        ? globalThis.Number(object.assertConfigDeviceConnectedToFabric)
        : 0,
      assertDeviceConnectedToFabric: isSet(object.assertDeviceConnectedToFabric)
        ? globalThis.Number(object.assertDeviceConnectedToFabric)
        : 0,
      assertConfigPortLinkDown: isSet(object.assertConfigPortLinkDown)
        ? globalThis.Number(object.assertConfigPortLinkDown)
        : 0,
      assertPortLinkDown: isSet(object.assertPortLinkDown) ? globalThis.Number(object.assertPortLinkDown) : 0,
      assertConfigPortConnectionSpeedMatch: isSet(object.assertConfigPortConnectionSpeedMatch)
        ? globalThis.Number(object.assertConfigPortConnectionSpeedMatch)
        : 0,
      assertPortConnectionSpeedMatch: isSet(object.assertPortConnectionSpeedMatch)
        ? globalThis.Number(object.assertPortConnectionSpeedMatch)
        : 0,
      assertConfigPortSpeedConsistent: isSet(object.assertConfigPortSpeedConsistent)
        ? globalThis.Number(object.assertConfigPortSpeedConsistent)
        : 0,
      assertPortSpeedConsistent: isSet(object.assertPortSpeedConsistent)
        ? globalThis.Number(object.assertPortSpeedConsistent)
        : 0,
      underlayInfo: isSet(object.underlayInfo) ? globalThis.Number(object.underlayInfo) : 0,
      proxyStats: isSet(object.proxyStats) ? globalThis.Number(object.proxyStats) : 0,
      vlanCounters: isSet(object.vlanCounters) ? globalThis.Number(object.vlanCounters) : 0,
      testPlaceHolder1Secret: isSet(object.testPlaceHolder1Secret)
        ? globalThis.Number(object.testPlaceHolder1Secret)
        : 0,
      assertConfigVlanHasTraffic: isSet(object.assertConfigVlanHasTraffic)
        ? globalThis.Number(object.assertConfigVlanHasTraffic)
        : 0,
      assertVlanHasTraffic: isSet(object.assertVlanHasTraffic) ? globalThis.Number(object.assertVlanHasTraffic) : 0,
      remoteVtep: isSet(object.remoteVtep) ? globalThis.Number(object.remoteVtep) : 0,
      qsfpDomThreshold: isSet(object.qsfpDomThreshold) ? globalThis.Number(object.qsfpDomThreshold) : 0,
      l3Table: isSet(object.l3Table) ? globalThis.String(object.l3Table) : "",
      vlanVniMap: isSet(object.vlanVniMap) ? globalThis.Number(object.vlanVniMap) : 0,
      proxyConnectionState: isSet(object.proxyConnectionState) ? globalThis.String(object.proxyConnectionState) : "",
      proxyConnectionStats: isSet(object.proxyConnectionStats) ? globalThis.Number(object.proxyConnectionStats) : 0,
      l2Mac: isSet(object.l2Mac) ? globalThis.String(object.l2Mac) : "",
      bmc: isSet(object.bmc) ? globalThis.Number(object.bmc) : 0,
      ipRouteTable: isSet(object.ipRouteTable) ? globalThis.String(object.ipRouteTable) : "",
      vrf: isSet(object.vrf) ? globalThis.String(object.vrf) : "",
      ipNextHop: isSet(object.ipNextHop) ? globalThis.Number(object.ipNextHop) : 0,
      ipPrefix: isSet(object.ipPrefix) ? globalThis.String(object.ipPrefix) : "",
      subInterface: isSet(object.subInterface) ? globalThis.Number(object.subInterface) : 0,
      assertConfigStaticDefaultRouteExists: isSet(object.assertConfigStaticDefaultRouteExists)
        ? globalThis.Number(object.assertConfigStaticDefaultRouteExists)
        : 0,
      assertStaticDefaultRouteExists: isSet(object.assertStaticDefaultRouteExists)
        ? globalThis.Number(object.assertStaticDefaultRouteExists)
        : 0,
      spyglassBrokerEntry: isSet(object.spyglassBrokerEntry) ? globalThis.String(object.spyglassBrokerEntry) : "",
      managementState: isSet(object.managementState) ? globalThis.String(object.managementState) : "",
      assertConfigManagementPortConfigSame: isSet(object.assertConfigManagementPortConfigSame)
        ? globalThis.Number(object.assertConfigManagementPortConfigSame)
        : 0,
      assertManagementPortConfigSame: isSet(object.assertManagementPortConfigSame)
        ? globalThis.Number(object.assertManagementPortConfigSame)
        : 0,
      fabricConfigNotification: isSet(object.fabricConfigNotification)
        ? globalThis.Number(object.fabricConfigNotification)
        : 0,
      spyglassGingerEntry: isSet(object.spyglassGingerEntry) ? globalThis.Number(object.spyglassGingerEntry) : 0,
      plannedConfig: isSet(object.plannedConfig) ? globalThis.Number(object.plannedConfig) : 0,
      routedInterfaceCounters: isSet(object.routedInterfaceCounters)
        ? globalThis.Number(object.routedInterfaceCounters)
        : 0,
      ipmRawLatencyCounters: isSet(object.ipmRawLatencyCounters) ? globalThis.Number(object.ipmRawLatencyCounters) : 0,
      ipmProcLatencyCounters: isSet(object.ipmProcLatencyCounters)
        ? globalThis.Number(object.ipmProcLatencyCounters)
        : 0,
      ipmProcLossCounters: isSet(object.ipmProcLossCounters) ? globalThis.Number(object.ipmProcLossCounters) : 0,
      ipmLivenessCounters: isSet(object.ipmLivenessCounters) ? globalThis.Number(object.ipmLivenessCounters) : 0,
      ipmSessionId: isSet(object.ipmSessionId) ? globalThis.String(object.ipmSessionId) : "",
      ipmProcJitterCounters: isSet(object.ipmProcJitterCounters) ? globalThis.Number(object.ipmProcJitterCounters) : 0,
      systemStats: isSet(object.systemStats) ? globalThis.Number(object.systemStats) : 0,
      testRootOne: isSet(object.testRootOne) ? globalThis.String(object.testRootOne) : "",
      testRootTwo: isSet(object.testRootTwo) ? globalThis.String(object.testRootTwo) : "",
      testMidOne: isSet(object.testMidOne) ? globalThis.Number(object.testMidOne) : 0,
      testLeafOne: isSet(object.testLeafOne) ? globalThis.String(object.testLeafOne) : "",
      testIpAddress: isSet(object.testIpAddress) ? globalThis.String(object.testIpAddress) : "",
      testIpPrefix: isSet(object.testIpPrefix) ? globalThis.String(object.testIpPrefix) : "",
      testMacAddress: isSet(object.testMacAddress) ? globalThis.String(object.testMacAddress) : "",
      assertConfigDeviceResourceUsageBelowThreshold: isSet(object.assertConfigDeviceResourceUsageBelowThreshold)
        ? globalThis.Number(object.assertConfigDeviceResourceUsageBelowThreshold)
        : 0,
      assertDeviceResourceUsageBelowThreshold: isSet(object.assertDeviceResourceUsageBelowThreshold)
        ? globalThis.Number(object.assertDeviceResourceUsageBelowThreshold)
        : 0,
      fabricTransaction: isSet(object.fabricTransaction) ? globalThis.String(object.fabricTransaction) : "0",
      bgpNeighborSummary: isSet(object.bgpNeighborSummary) ? globalThis.String(object.bgpNeighborSummary) : "",
      deviceConnection: isSet(object.deviceConnection) ? globalThis.Number(object.deviceConnection) : 0,
      bgpNeighborFamily: isSet(object.bgpNeighborFamily) ? globalThis.Number(object.bgpNeighborFamily) : 0,
      assertConfigBgpPeerEstablished: isSet(object.assertConfigBgpPeerEstablished)
        ? globalThis.Number(object.assertConfigBgpPeerEstablished)
        : 0,
      assertBgpPeerEstablished: isSet(object.assertBgpPeerEstablished)
        ? globalThis.Number(object.assertBgpPeerEstablished)
        : 0,
      spyglassSshSessionEntry: isSet(object.spyglassSshSessionEntry)
        ? globalThis.Number(object.spyglassSshSessionEntry)
        : 0,
      portChannelMemberState: isSet(object.portChannelMemberState)
        ? globalThis.String(object.portChannelMemberState)
        : "",
      portChannelState: isSet(object.portChannelState) ? globalThis.String(object.portChannelState) : "",
      spyglassDevice: isSet(object.spyglassDevice) ? globalThis.String(object.spyglassDevice) : "",
      spyglassTcpListener: isSet(object.spyglassTcpListener) ? globalThis.Number(object.spyglassTcpListener) : 0,
      spyglassTcpSession: isSet(object.spyglassTcpSession) ? globalThis.Number(object.spyglassTcpSession) : 0,
      unknownVlan: isSet(object.unknownVlan) ? globalThis.Number(object.unknownVlan) : 0,
      unknownVlanPort: isSet(object.unknownVlanPort) ? globalThis.String(object.unknownVlanPort) : "",
      assertConfigExpectedPortBreakoutExists: isSet(object.assertConfigExpectedPortBreakoutExists)
        ? globalThis.Number(object.assertConfigExpectedPortBreakoutExists)
        : 0,
      assertExpectedPortBreakoutExists: isSet(object.assertExpectedPortBreakoutExists)
        ? globalThis.Number(object.assertExpectedPortBreakoutExists)
        : 0,
      assertConfigSubInterfaceUp: isSet(object.assertConfigSubInterfaceUp)
        ? globalThis.Number(object.assertConfigSubInterfaceUp)
        : 0,
      assertSubInterfaceUp: isSet(object.assertSubInterfaceUp) ? globalThis.Number(object.assertSubInterfaceUp) : 0,
      assertSubInterfaceDown: isSet(object.assertSubInterfaceDown)
        ? globalThis.Number(object.assertSubInterfaceDown)
        : 0,
      assertConfigSubInterfaceDown: isSet(object.assertConfigSubInterfaceDown)
        ? globalThis.Number(object.assertConfigSubInterfaceDown)
        : 0,
      deviceClaim: isSet(object.deviceClaim) ? globalThis.Number(object.deviceClaim) : 0,
      aggregatedDeviceClaim: isSet(object.aggregatedDeviceClaim) ? globalThis.String(object.aggregatedDeviceClaim) : "",
      assertPortChannelMemberUp: isSet(object.assertPortChannelMemberUp)
        ? globalThis.Number(object.assertPortChannelMemberUp)
        : 0,
      assertConfigPortChannelMemberUp: isSet(object.assertConfigPortChannelMemberUp)
        ? globalThis.Number(object.assertConfigPortChannelMemberUp)
        : 0,
      esiInfo: isSet(object.esiInfo) ? globalThis.String(object.esiInfo) : "",
      esiVtepInfo: isSet(object.esiVtepInfo) ? globalThis.String(object.esiVtepInfo) : "",
      assertPortVlanStpStateConsistent: isSet(object.assertPortVlanStpStateConsistent)
        ? globalThis.Number(object.assertPortVlanStpStateConsistent)
        : 0,
      assertConfigPortVlanStpStateConsistent: isSet(object.assertConfigPortVlanStpStateConsistent)
        ? globalThis.Number(object.assertConfigPortVlanStpStateConsistent)
        : 0,
      assertPortPluggablePidSame: isSet(object.assertPortPluggablePidSame)
        ? globalThis.Number(object.assertPortPluggablePidSame)
        : 0,
      assertConfigPortPluggablePidSame: isSet(object.assertConfigPortPluggablePidSame)
        ? globalThis.Number(object.assertConfigPortPluggablePidSame)
        : 0,
      manifestImageState: isSet(object.manifestImageState) ? globalThis.Number(object.manifestImageState) : 0,
      portRateCounters: isSet(object.portRateCounters) ? globalThis.Number(object.portRateCounters) : 0,
      authorizedUserEntry: isSet(object.authorizedUserEntry) ? globalThis.String(object.authorizedUserEntry) : "",
      delegatedReadOnlyUserEntry: isSet(object.delegatedReadOnlyUserEntry)
        ? globalThis.String(object.delegatedReadOnlyUserEntry)
        : "",
      orgUuid: isSet(object.orgUuid) ? globalThis.String(object.orgUuid) : "",
      fabricUuid: isSet(object.fabricUuid) ? globalThis.String(object.fabricUuid) : "",
      apiPath: isSet(object.apiPath) ? globalThis.String(object.apiPath) : "",
      apiPathMethod: isSet(object.apiPathMethod) ? globalThis.String(object.apiPathMethod) : "",
      apiServiceMapping: isSet(object.apiServiceMapping) ? globalThis.Number(object.apiServiceMapping) : 0,
      orgToCellPairMapping: isSet(object.orgToCellPairMapping) ? globalThis.Number(object.orgToCellPairMapping) : 0,
      tenantUuid: isSet(object.tenantUuid) ? globalThis.String(object.tenantUuid) : "",
      userEmail: isSet(object.userEmail) ? globalThis.String(object.userEmail) : "",
      managementConfig: isSet(object.managementConfig) ? globalThis.Number(object.managementConfig) : 0,
      serviceInstanceHealth: isSet(object.serviceInstanceHealth) ? globalThis.String(object.serviceInstanceHealth) : "",
      assignmentStatus: isSet(object.assignmentStatus) ? globalThis.String(object.assignmentStatus) : "",
      kubernetesServiceInstance: isSet(object.kubernetesServiceInstance)
        ? globalThis.String(object.kubernetesServiceInstance)
        : "",
      bearerToken: isSet(object.bearerToken) ? globalThis.String(object.bearerToken) : "",
      apiKey: isSet(object.apiKey) ? globalThis.String(object.apiKey) : "",
      fabricMemoryUsage: isSet(object.fabricMemoryUsage) ? globalThis.String(object.fabricMemoryUsage) : "",
      typeMemoryUsage: isSet(object.typeMemoryUsage) ? globalThis.Number(object.typeMemoryUsage) : 0,
      manifestRunningImageStatus: isSet(object.manifestRunningImageStatus)
        ? globalThis.Number(object.manifestRunningImageStatus)
        : 0,
      manifestPartitionFileCacheStatus: isSet(object.manifestPartitionFileCacheStatus)
        ? globalThis.String(object.manifestPartitionFileCacheStatus)
        : "",
      stpPortState: isSet(object.stpPortState) ? globalThis.String(object.stpPortState) : "",
      stpVlanState: isSet(object.stpVlanState) ? globalThis.Number(object.stpVlanState) : 0,
      stpVlanPortState: isSet(object.stpVlanPortState) ? globalThis.String(object.stpVlanPortState) : "",
      unpackAndAssembleTask: isSet(object.unpackAndAssembleTask) ? globalThis.Number(object.unpackAndAssembleTask) : 0,
      claimAndBindTask: isSet(object.claimAndBindTask) ? globalThis.Number(object.claimAndBindTask) : 0,
      portSetupTask: isSet(object.portSetupTask) ? globalThis.Number(object.portSetupTask) : 0,
      fabricConnectionTask: isSet(object.fabricConnectionTask) ? globalThis.Number(object.fabricConnectionTask) : 0,
      negativeConnectionTask: isSet(object.negativeConnectionTask)
        ? globalThis.Number(object.negativeConnectionTask)
        : 0,
      application: isSet(object.application) ? globalThis.Number(object.application) : 0,
      resourceAssignment: isSet(object.resourceAssignment) ? globalThis.String(object.resourceAssignment) : "",
      node: isSet(object.node) ? globalThis.String(object.node) : "",
      nodeLineCard: isSet(object.nodeLineCard) ? globalThis.Number(object.nodeLineCard) : 0,
      nodePort: isSet(object.nodePort) ? globalThis.Number(object.nodePort) : 0,
      nodeBreakout: isSet(object.nodeBreakout) ? globalThis.Number(object.nodeBreakout) : 0,
      tenantMetadata: isSet(object.tenantMetadata) ? globalThis.Number(object.tenantMetadata) : 0,
      assertPortNoUnknownVlanFound: isSet(object.assertPortNoUnknownVlanFound)
        ? globalThis.Number(object.assertPortNoUnknownVlanFound)
        : 0,
      assertConfigPortNoUnknownVlanFound: isSet(object.assertConfigPortNoUnknownVlanFound)
        ? globalThis.Number(object.assertConfigPortNoUnknownVlanFound)
        : 0,
      bulkUpliftJobRequest: isSet(object.bulkUpliftJobRequest) ? globalThis.String(object.bulkUpliftJobRequest) : "",
      bulkUpliftJobStatus: isSet(object.bulkUpliftJobStatus) ? globalThis.String(object.bulkUpliftJobStatus) : "",
      bgpNeighborInfo: isSet(object.bgpNeighborInfo) ? globalThis.String(object.bgpNeighborInfo) : "",
      refPoint: isSet(object.refPoint) ? globalThis.String(object.refPoint) : "",
      refPointStatus: isSet(object.refPointStatus) ? globalThis.String(object.refPointStatus) : "",
      userPreferenceItem: isSet(object.userPreferenceItem) ? globalThis.String(object.userPreferenceItem) : "",
      bgpNeighborReceivedRoute: isSet(object.bgpNeighborReceivedRoute)
        ? globalThis.String(object.bgpNeighborReceivedRoute)
        : "",
      userEula: isSet(object.userEula) ? globalThis.String(object.userEula) : "",
      brigSymmetricSigningKey: isSet(object.brigSymmetricSigningKey)
        ? globalThis.Number(object.brigSymmetricSigningKey)
        : 0,
      firmwareVersion: isSet(object.firmwareVersion) ? globalThis.Number(object.firmwareVersion) : 0,
      serverIpRouteAddress: isSet(object.serverIpRouteAddress) ? globalThis.String(object.serverIpRouteAddress) : "",
      serverIpRouteTable: isSet(object.serverIpRouteTable) ? globalThis.String(object.serverIpRouteTable) : "",
      apiPathProtocol: isSet(object.apiPathProtocol) ? globalThis.Number(object.apiPathProtocol) : 0,
      serverPsu: isSet(object.serverPsu) ? globalThis.String(object.serverPsu) : "",
      serverTempSensor: isSet(object.serverTempSensor) ? globalThis.Number(object.serverTempSensor) : 0,
      loadBalancedSvcRoute: isSet(object.loadBalancedSvcRoute) ? globalThis.Number(object.loadBalancedSvcRoute) : 0,
      assignmentSvcRoute: isSet(object.assignmentSvcRoute) ? globalThis.String(object.assignmentSvcRoute) : "",
      dbTableUpdateNotification: isSet(object.dbTableUpdateNotification)
        ? globalThis.Number(object.dbTableUpdateNotification)
        : 0,
      assertDeviceFanSpeedBelowThreshold: isSet(object.assertDeviceFanSpeedBelowThreshold)
        ? globalThis.Number(object.assertDeviceFanSpeedBelowThreshold)
        : 0,
      assertConfigDeviceFanSpeedBelowThreshold: isSet(object.assertConfigDeviceFanSpeedBelowThreshold)
        ? globalThis.Number(object.assertConfigDeviceFanSpeedBelowThreshold)
        : 0,
      assertDeviceTemperatureBelowThreshold: isSet(object.assertDeviceTemperatureBelowThreshold)
        ? globalThis.Number(object.assertDeviceTemperatureBelowThreshold)
        : 0,
      assertConfigDeviceTemperatureBelowThreshold: isSet(object.assertConfigDeviceTemperatureBelowThreshold)
        ? globalThis.Number(object.assertConfigDeviceTemperatureBelowThreshold)
        : 0,
      activeWorker: isSet(object.activeWorker) ? globalThis.String(object.activeWorker) : "",
      serverFan: isSet(object.serverFan) ? globalThis.Number(object.serverFan) : 0,
      serverPortInfo: isSet(object.serverPortInfo) ? globalThis.Number(object.serverPortInfo) : 0,
      assertDevicePsuUsageBelowThreshold: isSet(object.assertDevicePsuUsageBelowThreshold)
        ? globalThis.Number(object.assertDevicePsuUsageBelowThreshold)
        : 0,
      assertConfigDevicePsuUsageBelowThreshold: isSet(object.assertConfigDevicePsuUsageBelowThreshold)
        ? globalThis.Number(object.assertConfigDevicePsuUsageBelowThreshold)
        : 0,
      bmcServer: isSet(object.bmcServer) ? globalThis.String(object.bmcServer) : "",
      bmcServerPsu: isSet(object.bmcServerPsu) ? globalThis.String(object.bmcServerPsu) : "",
      bmcServerTempSensor: isSet(object.bmcServerTempSensor) ? globalThis.Number(object.bmcServerTempSensor) : 0,
      bmcServerFan: isSet(object.bmcServerFan) ? globalThis.Number(object.bmcServerFan) : 0,
      bmcServerPortInfo: isSet(object.bmcServerPortInfo) ? globalThis.Number(object.bmcServerPortInfo) : 0,
      ipRouteJoinedView: isSet(object.ipRouteJoinedView) ? globalThis.Number(object.ipRouteJoinedView) : 0,
      serverToBmc: isSet(object.serverToBmc) ? globalThis.Number(object.serverToBmc) : 0,
      serverMac: isSet(object.serverMac) ? globalThis.String(object.serverMac) : "",
      serverInterface: isSet(object.serverInterface) ? globalThis.String(object.serverInterface) : "",
      serverL3Table: isSet(object.serverL3Table) ? globalThis.String(object.serverL3Table) : "",
      serverInterfaceInfo: isSet(object.serverInterfaceInfo) ? globalThis.String(object.serverInterfaceInfo) : "",
      pluggableConnectionInfo: isSet(object.pluggableConnectionInfo)
        ? globalThis.Number(object.pluggableConnectionInfo)
        : 0,
      ipRouteJoinedViewCountSpace: isSet(object.ipRouteJoinedViewCountSpace)
        ? globalThis.String(object.ipRouteJoinedViewCountSpace)
        : "",
      ipRouteJoinedViewCount: isSet(object.ipRouteJoinedViewCount)
        ? globalThis.Number(object.ipRouteJoinedViewCount)
        : 0,
      l2FdbBucketed: isSet(object.l2FdbBucketed) ? globalThis.String(object.l2FdbBucketed) : "",
      l2FdbSingle: isSet(object.l2FdbSingle) ? globalThis.String(object.l2FdbSingle) : "",
      l2FdbSingleVlan: isSet(object.l2FdbSingleVlan) ? globalThis.Number(object.l2FdbSingleVlan) : 0,
      signingKey: isSet(object.signingKey) ? globalThis.String(object.signingKey) : "",
      bgpNeighborAdvertisedRoute: isSet(object.bgpNeighborAdvertisedRoute)
        ? globalThis.String(object.bgpNeighborAdvertisedRoute)
        : "",
      serverInterfaceMapping: isSet(object.serverInterfaceMapping)
        ? globalThis.Number(object.serverInterfaceMapping)
        : 0,
      signingKeyFlavor: isSet(object.signingKeyFlavor) ? globalThis.Number(object.signingKeyFlavor) : 0,
      ipSlaProbe: isSet(object.ipSlaProbe) ? globalThis.String(object.ipSlaProbe) : "",
      staticRoute: isSet(object.staticRoute) ? globalThis.String(object.staticRoute) : "",
      interconnect: isSet(object.interconnect) ? globalThis.String(object.interconnect) : "",
      interconnectTransaction: isSet(object.interconnectTransaction)
        ? globalThis.String(object.interconnectTransaction)
        : "0",
      orgMetadata: isSet(object.orgMetadata) ? globalThis.Number(object.orgMetadata) : 0,
      fabricInterconnectConfig: isSet(object.fabricInterconnectConfig)
        ? globalThis.String(object.fabricInterconnectConfig)
        : "",
      spanSession: isSet(object.spanSession) ? globalThis.String(object.spanSession) : "",
      portVlanInfo: isSet(object.portVlanInfo) ? globalThis.Number(object.portVlanInfo) : 0,
      bgpRouteStats: isSet(object.bgpRouteStats) ? globalThis.Number(object.bgpRouteStats) : 0,
      vniMacCounts: isSet(object.vniMacCounts) ? globalThis.Number(object.vniMacCounts) : 0,
      gpuDevice: isSet(object.gpuDevice) ? globalThis.Number(object.gpuDevice) : 0,
      vxlanTunnel: isSet(object.vxlanTunnel) ? globalThis.String(object.vxlanTunnel) : "",
      vxlanTunnelMapping: isSet(object.vxlanTunnelMapping) ? globalThis.String(object.vxlanTunnelMapping) : "",
      vxlanRemoteVtepMapping: isSet(object.vxlanRemoteVtepMapping)
        ? globalThis.String(object.vxlanRemoteVtepMapping)
        : "",
      assertConfigMultisiteLinkUp: isSet(object.assertConfigMultisiteLinkUp)
        ? globalThis.Number(object.assertConfigMultisiteLinkUp)
        : 0,
      assertMultisiteLinkUp: isSet(object.assertMultisiteLinkUp) ? globalThis.Number(object.assertMultisiteLinkUp) : 0,
      multisiteLink: isSet(object.multisiteLink) ? globalThis.String(object.multisiteLink) : "",
      twampSession: isSet(object.twampSession) ? globalThis.Number(object.twampSession) : 0,
      assertConfigPortQsfpHealthy: isSet(object.assertConfigPortQsfpHealthy)
        ? globalThis.Number(object.assertConfigPortQsfpHealthy)
        : 0,
      assertPortQsfpHealthy: isSet(object.assertPortQsfpHealthy) ? globalThis.Number(object.assertPortQsfpHealthy) : 0,
      assertConfigMultisiteLatencyStable: isSet(object.assertConfigMultisiteLatencyStable)
        ? globalThis.Number(object.assertConfigMultisiteLatencyStable)
        : 0,
      assertMultisiteLatencyStable: isSet(object.assertMultisiteLatencyStable)
        ? globalThis.Number(object.assertMultisiteLatencyStable)
        : 0,
      l2FdbBucketedMultisite: isSet(object.l2FdbBucketedMultisite)
        ? globalThis.String(object.l2FdbBucketedMultisite)
        : "",
      commandRequest: isSet(object.commandRequest) ? globalThis.String(object.commandRequest) : "",
      commandOutput: isSet(object.commandOutput) ? globalThis.String(object.commandOutput) : "",
      commandOutputRecord: isSet(object.commandOutputRecord) ? globalThis.Number(object.commandOutputRecord) : 0,
      assertConfigMultisiteExpectedMtu: isSet(object.assertConfigMultisiteExpectedMtu)
        ? globalThis.Number(object.assertConfigMultisiteExpectedMtu)
        : 0,
      assertMultisiteExpectedMtu: isSet(object.assertMultisiteExpectedMtu)
        ? globalThis.Number(object.assertMultisiteExpectedMtu)
        : 0,
      imageManifestInfo: isSet(object.imageManifestInfo) ? globalThis.Number(object.imageManifestInfo) : 0,
      ipRouteFabricJoinedViewCountSpace: isSet(object.ipRouteFabricJoinedViewCountSpace)
        ? globalThis.String(object.ipRouteFabricJoinedViewCountSpace)
        : "",
      ipRouteFabricJoinedViewCount: isSet(object.ipRouteFabricJoinedViewCount)
        ? globalThis.Number(object.ipRouteFabricJoinedViewCount)
        : 0,
      borderPort: isSet(object.borderPort) ? globalThis.Number(object.borderPort) : 0,
      networkInterfaceSummary: isSet(object.networkInterfaceSummary)
        ? globalThis.String(object.networkInterfaceSummary)
        : "",
      vrfEndpointCounts: isSet(object.vrfEndpointCounts) ? globalThis.String(object.vrfEndpointCounts) : "",
      assertConfigNxosDeviceExpectedFeatures: isSet(object.assertConfigNxosDeviceExpectedFeatures)
        ? globalThis.Number(object.assertConfigNxosDeviceExpectedFeatures)
        : 0,
      assertNxosDeviceExpectedFeatures: isSet(object.assertNxosDeviceExpectedFeatures)
        ? globalThis.Number(object.assertNxosDeviceExpectedFeatures)
        : 0,
      opticsFirmwareUpdate: isSet(object.opticsFirmwareUpdate) ? globalThis.Number(object.opticsFirmwareUpdate) : 0,
      arsConfig: isSet(object.arsConfig) ? globalThis.String(object.arsConfig) : "",
      softwareUpdateStatus: isSet(object.softwareUpdateStatus) ? globalThis.Number(object.softwareUpdateStatus) : 0,
      vxlanRemoteVtepInfo: isSet(object.vxlanRemoteVtepInfo) ? globalThis.String(object.vxlanRemoteVtepInfo) : "",
      arsInfo: isSet(object.arsInfo) ? globalThis.Number(object.arsInfo) : 0,
      cellPair: isSet(object.cellPair) ? globalThis.String(object.cellPair) : "",
      arsPortInfo: isSet(object.arsPortInfo) ? globalThis.Number(object.arsPortInfo) : 0,
      fabricRack: isSet(object.fabricRack) ? globalThis.String(object.fabricRack) : "",
      iterativeSpiderClaim: isSet(object.iterativeSpiderClaim) ? globalThis.String(object.iterativeSpiderClaim) : "",
      invalidUserSession: isSet(object.invalidUserSession) ? globalThis.String(object.invalidUserSession) : "",
      systemHealth: isSet(object.systemHealth) ? globalThis.Number(object.systemHealth) : 0,
      portVlanAssertSummary: isSet(object.portVlanAssertSummary) ? globalThis.String(object.portVlanAssertSummary) : "",
      serverNetworkAdapter: isSet(object.serverNetworkAdapter) ? globalThis.String(object.serverNetworkAdapter) : "",
      bmcServerNetworkAdapter: isSet(object.bmcServerNetworkAdapter)
        ? globalThis.String(object.bmcServerNetworkAdapter)
        : "",
      serverProcessor: isSet(object.serverProcessor) ? globalThis.String(object.serverProcessor) : "",
      bmcServerProcessor: isSet(object.bmcServerProcessor) ? globalThis.String(object.bmcServerProcessor) : "",
    };
  },

  toJSON(message: PathId): unknown {
    const obj: any = {};
    if (message.deleted !== false) {
      obj.deleted = message.deleted;
    }
    if (message.pathString !== "") {
      obj.pathString = message.pathString;
    }
    if (message.type !== 0) {
      obj.type = schemaTypeToJSON(message.type);
    }
    if (message.fabric !== "") {
      obj.fabric = message.fabric;
    }
    if (message.device !== "") {
      obj.device = message.device;
    }
    if (message.fan !== 0) {
      obj.fan = Math.round(message.fan);
    }
    if (message.psu !== 0) {
      obj.psu = Math.round(message.psu);
    }
    if (message.tempSensor !== 0) {
      obj.tempSensor = Math.round(message.tempSensor);
    }
    if (message.lineCard !== 0) {
      obj.lineCard = Math.round(message.lineCard);
    }
    if (message.port !== 0) {
      obj.port = Math.round(message.port);
    }
    if (message.dacQsfp !== 0) {
      obj.dacQsfp = Math.round(message.dacQsfp);
    }
    if (message.fiberQsfp !== 0) {
      obj.fiberQsfp = Math.round(message.fiberQsfp);
    }
    if (message.breakout !== 0) {
      obj.breakout = Math.round(message.breakout);
    }
    if (message.portNeighbor !== "") {
      obj.portNeighbor = message.portNeighbor;
    }
    if (message.vtep !== 0) {
      obj.vtep = Math.round(message.vtep);
    }
    if (message.vniPort !== 0) {
      obj.vniPort = Math.round(message.vniPort);
    }
    if (message.mac !== 0) {
      obj.mac = Math.round(message.mac);
    }
    if (message.procTable !== 0) {
      obj.procTable = Math.round(message.procTable);
    }
    if (message.portVlan !== "") {
      obj.portVlan = message.portVlan;
    }
    if (message.vlanState !== 0) {
      obj.vlanState = Math.round(message.vlanState);
    }
    if (message.qsfpDomSensor !== 0) {
      obj.qsfpDomSensor = Math.round(message.qsfpDomSensor);
    }
    if (message.portConfig !== 0) {
      obj.portConfig = Math.round(message.portConfig);
    }
    if (message.nodeConfig !== 0) {
      obj.nodeConfig = Math.round(message.nodeConfig);
    }
    if (message.fabricConfig !== "") {
      obj.fabricConfig = message.fabricConfig;
    }
    if (message.fabricConfigEvent !== 0) {
      obj.fabricConfigEvent = Math.round(message.fabricConfigEvent);
    }
    if (message.l2Fdb !== 0) {
      obj.l2Fdb = Math.round(message.l2Fdb);
    }
    if (message.portCounters !== 0) {
      obj.portCounters = Math.round(message.portCounters);
    }
    if (message.remedyAction !== "") {
      obj.remedyAction = message.remedyAction;
    }
    if (message.qsfpInfo !== 0) {
      obj.qsfpInfo = Math.round(message.qsfpInfo);
    }
    if (message.fabricDevice !== "") {
      obj.fabricDevice = message.fabricDevice;
    }
    if (message.assertConfigPortLinkUp !== 0) {
      obj.assertConfigPortLinkUp = Math.round(message.assertConfigPortLinkUp);
    }
    if (message.assertPortLinkUp !== 0) {
      obj.assertPortLinkUp = Math.round(message.assertPortLinkUp);
    }
    if (message.assertConfigDeviceConnectedToCloud !== 0) {
      obj.assertConfigDeviceConnectedToCloud = Math.round(message.assertConfigDeviceConnectedToCloud);
    }
    if (message.assertDeviceConnectedToCloud !== 0) {
      obj.assertDeviceConnectedToCloud = Math.round(message.assertDeviceConnectedToCloud);
    }
    if (message.assertConfigPortExpectedNeighbor !== 0) {
      obj.assertConfigPortExpectedNeighbor = Math.round(message.assertConfigPortExpectedNeighbor);
    }
    if (message.assertPortExpectedNeighbor !== 0) {
      obj.assertPortExpectedNeighbor = Math.round(message.assertPortExpectedNeighbor);
    }
    if (message.assertConfigPortNotConnectedToFabric !== 0) {
      obj.assertConfigPortNotConnectedToFabric = Math.round(message.assertConfigPortNotConnectedToFabric);
    }
    if (message.assertPortNotConnectedToFabric !== 0) {
      obj.assertPortNotConnectedToFabric = Math.round(message.assertPortNotConnectedToFabric);
    }
    if (message.assertConfigDeviceConnectedToFabric !== 0) {
      obj.assertConfigDeviceConnectedToFabric = Math.round(message.assertConfigDeviceConnectedToFabric);
    }
    if (message.assertDeviceConnectedToFabric !== 0) {
      obj.assertDeviceConnectedToFabric = Math.round(message.assertDeviceConnectedToFabric);
    }
    if (message.assertConfigPortLinkDown !== 0) {
      obj.assertConfigPortLinkDown = Math.round(message.assertConfigPortLinkDown);
    }
    if (message.assertPortLinkDown !== 0) {
      obj.assertPortLinkDown = Math.round(message.assertPortLinkDown);
    }
    if (message.assertConfigPortConnectionSpeedMatch !== 0) {
      obj.assertConfigPortConnectionSpeedMatch = Math.round(message.assertConfigPortConnectionSpeedMatch);
    }
    if (message.assertPortConnectionSpeedMatch !== 0) {
      obj.assertPortConnectionSpeedMatch = Math.round(message.assertPortConnectionSpeedMatch);
    }
    if (message.assertConfigPortSpeedConsistent !== 0) {
      obj.assertConfigPortSpeedConsistent = Math.round(message.assertConfigPortSpeedConsistent);
    }
    if (message.assertPortSpeedConsistent !== 0) {
      obj.assertPortSpeedConsistent = Math.round(message.assertPortSpeedConsistent);
    }
    if (message.underlayInfo !== 0) {
      obj.underlayInfo = Math.round(message.underlayInfo);
    }
    if (message.proxyStats !== 0) {
      obj.proxyStats = Math.round(message.proxyStats);
    }
    if (message.vlanCounters !== 0) {
      obj.vlanCounters = Math.round(message.vlanCounters);
    }
    if (message.testPlaceHolder1Secret !== 0) {
      obj.testPlaceHolder1Secret = Math.round(message.testPlaceHolder1Secret);
    }
    if (message.assertConfigVlanHasTraffic !== 0) {
      obj.assertConfigVlanHasTraffic = Math.round(message.assertConfigVlanHasTraffic);
    }
    if (message.assertVlanHasTraffic !== 0) {
      obj.assertVlanHasTraffic = Math.round(message.assertVlanHasTraffic);
    }
    if (message.remoteVtep !== 0) {
      obj.remoteVtep = Math.round(message.remoteVtep);
    }
    if (message.qsfpDomThreshold !== 0) {
      obj.qsfpDomThreshold = Math.round(message.qsfpDomThreshold);
    }
    if (message.l3Table !== "") {
      obj.l3Table = message.l3Table;
    }
    if (message.vlanVniMap !== 0) {
      obj.vlanVniMap = Math.round(message.vlanVniMap);
    }
    if (message.proxyConnectionState !== "") {
      obj.proxyConnectionState = message.proxyConnectionState;
    }
    if (message.proxyConnectionStats !== 0) {
      obj.proxyConnectionStats = Math.round(message.proxyConnectionStats);
    }
    if (message.l2Mac !== "") {
      obj.l2Mac = message.l2Mac;
    }
    if (message.bmc !== 0) {
      obj.bmc = Math.round(message.bmc);
    }
    if (message.ipRouteTable !== "") {
      obj.ipRouteTable = message.ipRouteTable;
    }
    if (message.vrf !== "") {
      obj.vrf = message.vrf;
    }
    if (message.ipNextHop !== 0) {
      obj.ipNextHop = Math.round(message.ipNextHop);
    }
    if (message.ipPrefix !== "") {
      obj.ipPrefix = message.ipPrefix;
    }
    if (message.subInterface !== 0) {
      obj.subInterface = Math.round(message.subInterface);
    }
    if (message.assertConfigStaticDefaultRouteExists !== 0) {
      obj.assertConfigStaticDefaultRouteExists = Math.round(message.assertConfigStaticDefaultRouteExists);
    }
    if (message.assertStaticDefaultRouteExists !== 0) {
      obj.assertStaticDefaultRouteExists = Math.round(message.assertStaticDefaultRouteExists);
    }
    if (message.spyglassBrokerEntry !== "") {
      obj.spyglassBrokerEntry = message.spyglassBrokerEntry;
    }
    if (message.managementState !== "") {
      obj.managementState = message.managementState;
    }
    if (message.assertConfigManagementPortConfigSame !== 0) {
      obj.assertConfigManagementPortConfigSame = Math.round(message.assertConfigManagementPortConfigSame);
    }
    if (message.assertManagementPortConfigSame !== 0) {
      obj.assertManagementPortConfigSame = Math.round(message.assertManagementPortConfigSame);
    }
    if (message.fabricConfigNotification !== 0) {
      obj.fabricConfigNotification = Math.round(message.fabricConfigNotification);
    }
    if (message.spyglassGingerEntry !== 0) {
      obj.spyglassGingerEntry = Math.round(message.spyglassGingerEntry);
    }
    if (message.plannedConfig !== 0) {
      obj.plannedConfig = Math.round(message.plannedConfig);
    }
    if (message.routedInterfaceCounters !== 0) {
      obj.routedInterfaceCounters = Math.round(message.routedInterfaceCounters);
    }
    if (message.ipmRawLatencyCounters !== 0) {
      obj.ipmRawLatencyCounters = Math.round(message.ipmRawLatencyCounters);
    }
    if (message.ipmProcLatencyCounters !== 0) {
      obj.ipmProcLatencyCounters = Math.round(message.ipmProcLatencyCounters);
    }
    if (message.ipmProcLossCounters !== 0) {
      obj.ipmProcLossCounters = Math.round(message.ipmProcLossCounters);
    }
    if (message.ipmLivenessCounters !== 0) {
      obj.ipmLivenessCounters = Math.round(message.ipmLivenessCounters);
    }
    if (message.ipmSessionId !== "") {
      obj.ipmSessionId = message.ipmSessionId;
    }
    if (message.ipmProcJitterCounters !== 0) {
      obj.ipmProcJitterCounters = Math.round(message.ipmProcJitterCounters);
    }
    if (message.systemStats !== 0) {
      obj.systemStats = Math.round(message.systemStats);
    }
    if (message.testRootOne !== "") {
      obj.testRootOne = message.testRootOne;
    }
    if (message.testRootTwo !== "") {
      obj.testRootTwo = message.testRootTwo;
    }
    if (message.testMidOne !== 0) {
      obj.testMidOne = Math.round(message.testMidOne);
    }
    if (message.testLeafOne !== "") {
      obj.testLeafOne = message.testLeafOne;
    }
    if (message.testIpAddress !== "") {
      obj.testIpAddress = message.testIpAddress;
    }
    if (message.testIpPrefix !== "") {
      obj.testIpPrefix = message.testIpPrefix;
    }
    if (message.testMacAddress !== "") {
      obj.testMacAddress = message.testMacAddress;
    }
    if (message.assertConfigDeviceResourceUsageBelowThreshold !== 0) {
      obj.assertConfigDeviceResourceUsageBelowThreshold = Math.round(
        message.assertConfigDeviceResourceUsageBelowThreshold,
      );
    }
    if (message.assertDeviceResourceUsageBelowThreshold !== 0) {
      obj.assertDeviceResourceUsageBelowThreshold = Math.round(message.assertDeviceResourceUsageBelowThreshold);
    }
    if (message.fabricTransaction !== "0") {
      obj.fabricTransaction = message.fabricTransaction;
    }
    if (message.bgpNeighborSummary !== "") {
      obj.bgpNeighborSummary = message.bgpNeighborSummary;
    }
    if (message.deviceConnection !== 0) {
      obj.deviceConnection = Math.round(message.deviceConnection);
    }
    if (message.bgpNeighborFamily !== 0) {
      obj.bgpNeighborFamily = Math.round(message.bgpNeighborFamily);
    }
    if (message.assertConfigBgpPeerEstablished !== 0) {
      obj.assertConfigBgpPeerEstablished = Math.round(message.assertConfigBgpPeerEstablished);
    }
    if (message.assertBgpPeerEstablished !== 0) {
      obj.assertBgpPeerEstablished = Math.round(message.assertBgpPeerEstablished);
    }
    if (message.spyglassSshSessionEntry !== 0) {
      obj.spyglassSshSessionEntry = Math.round(message.spyglassSshSessionEntry);
    }
    if (message.portChannelMemberState !== "") {
      obj.portChannelMemberState = message.portChannelMemberState;
    }
    if (message.portChannelState !== "") {
      obj.portChannelState = message.portChannelState;
    }
    if (message.spyglassDevice !== "") {
      obj.spyglassDevice = message.spyglassDevice;
    }
    if (message.spyglassTcpListener !== 0) {
      obj.spyglassTcpListener = Math.round(message.spyglassTcpListener);
    }
    if (message.spyglassTcpSession !== 0) {
      obj.spyglassTcpSession = Math.round(message.spyglassTcpSession);
    }
    if (message.unknownVlan !== 0) {
      obj.unknownVlan = Math.round(message.unknownVlan);
    }
    if (message.unknownVlanPort !== "") {
      obj.unknownVlanPort = message.unknownVlanPort;
    }
    if (message.assertConfigExpectedPortBreakoutExists !== 0) {
      obj.assertConfigExpectedPortBreakoutExists = Math.round(message.assertConfigExpectedPortBreakoutExists);
    }
    if (message.assertExpectedPortBreakoutExists !== 0) {
      obj.assertExpectedPortBreakoutExists = Math.round(message.assertExpectedPortBreakoutExists);
    }
    if (message.assertConfigSubInterfaceUp !== 0) {
      obj.assertConfigSubInterfaceUp = Math.round(message.assertConfigSubInterfaceUp);
    }
    if (message.assertSubInterfaceUp !== 0) {
      obj.assertSubInterfaceUp = Math.round(message.assertSubInterfaceUp);
    }
    if (message.assertSubInterfaceDown !== 0) {
      obj.assertSubInterfaceDown = Math.round(message.assertSubInterfaceDown);
    }
    if (message.assertConfigSubInterfaceDown !== 0) {
      obj.assertConfigSubInterfaceDown = Math.round(message.assertConfigSubInterfaceDown);
    }
    if (message.deviceClaim !== 0) {
      obj.deviceClaim = Math.round(message.deviceClaim);
    }
    if (message.aggregatedDeviceClaim !== "") {
      obj.aggregatedDeviceClaim = message.aggregatedDeviceClaim;
    }
    if (message.assertPortChannelMemberUp !== 0) {
      obj.assertPortChannelMemberUp = Math.round(message.assertPortChannelMemberUp);
    }
    if (message.assertConfigPortChannelMemberUp !== 0) {
      obj.assertConfigPortChannelMemberUp = Math.round(message.assertConfigPortChannelMemberUp);
    }
    if (message.esiInfo !== "") {
      obj.esiInfo = message.esiInfo;
    }
    if (message.esiVtepInfo !== "") {
      obj.esiVtepInfo = message.esiVtepInfo;
    }
    if (message.assertPortVlanStpStateConsistent !== 0) {
      obj.assertPortVlanStpStateConsistent = Math.round(message.assertPortVlanStpStateConsistent);
    }
    if (message.assertConfigPortVlanStpStateConsistent !== 0) {
      obj.assertConfigPortVlanStpStateConsistent = Math.round(message.assertConfigPortVlanStpStateConsistent);
    }
    if (message.assertPortPluggablePidSame !== 0) {
      obj.assertPortPluggablePidSame = Math.round(message.assertPortPluggablePidSame);
    }
    if (message.assertConfigPortPluggablePidSame !== 0) {
      obj.assertConfigPortPluggablePidSame = Math.round(message.assertConfigPortPluggablePidSame);
    }
    if (message.manifestImageState !== 0) {
      obj.manifestImageState = Math.round(message.manifestImageState);
    }
    if (message.portRateCounters !== 0) {
      obj.portRateCounters = Math.round(message.portRateCounters);
    }
    if (message.authorizedUserEntry !== "") {
      obj.authorizedUserEntry = message.authorizedUserEntry;
    }
    if (message.delegatedReadOnlyUserEntry !== "") {
      obj.delegatedReadOnlyUserEntry = message.delegatedReadOnlyUserEntry;
    }
    if (message.orgUuid !== "") {
      obj.orgUuid = message.orgUuid;
    }
    if (message.fabricUuid !== "") {
      obj.fabricUuid = message.fabricUuid;
    }
    if (message.apiPath !== "") {
      obj.apiPath = message.apiPath;
    }
    if (message.apiPathMethod !== "") {
      obj.apiPathMethod = message.apiPathMethod;
    }
    if (message.apiServiceMapping !== 0) {
      obj.apiServiceMapping = Math.round(message.apiServiceMapping);
    }
    if (message.orgToCellPairMapping !== 0) {
      obj.orgToCellPairMapping = Math.round(message.orgToCellPairMapping);
    }
    if (message.tenantUuid !== "") {
      obj.tenantUuid = message.tenantUuid;
    }
    if (message.userEmail !== "") {
      obj.userEmail = message.userEmail;
    }
    if (message.managementConfig !== 0) {
      obj.managementConfig = Math.round(message.managementConfig);
    }
    if (message.serviceInstanceHealth !== "") {
      obj.serviceInstanceHealth = message.serviceInstanceHealth;
    }
    if (message.assignmentStatus !== "") {
      obj.assignmentStatus = message.assignmentStatus;
    }
    if (message.kubernetesServiceInstance !== "") {
      obj.kubernetesServiceInstance = message.kubernetesServiceInstance;
    }
    if (message.bearerToken !== "") {
      obj.bearerToken = message.bearerToken;
    }
    if (message.apiKey !== "") {
      obj.apiKey = message.apiKey;
    }
    if (message.fabricMemoryUsage !== "") {
      obj.fabricMemoryUsage = message.fabricMemoryUsage;
    }
    if (message.typeMemoryUsage !== 0) {
      obj.typeMemoryUsage = Math.round(message.typeMemoryUsage);
    }
    if (message.manifestRunningImageStatus !== 0) {
      obj.manifestRunningImageStatus = Math.round(message.manifestRunningImageStatus);
    }
    if (message.manifestPartitionFileCacheStatus !== "") {
      obj.manifestPartitionFileCacheStatus = message.manifestPartitionFileCacheStatus;
    }
    if (message.stpPortState !== "") {
      obj.stpPortState = message.stpPortState;
    }
    if (message.stpVlanState !== 0) {
      obj.stpVlanState = Math.round(message.stpVlanState);
    }
    if (message.stpVlanPortState !== "") {
      obj.stpVlanPortState = message.stpVlanPortState;
    }
    if (message.unpackAndAssembleTask !== 0) {
      obj.unpackAndAssembleTask = Math.round(message.unpackAndAssembleTask);
    }
    if (message.claimAndBindTask !== 0) {
      obj.claimAndBindTask = Math.round(message.claimAndBindTask);
    }
    if (message.portSetupTask !== 0) {
      obj.portSetupTask = Math.round(message.portSetupTask);
    }
    if (message.fabricConnectionTask !== 0) {
      obj.fabricConnectionTask = Math.round(message.fabricConnectionTask);
    }
    if (message.negativeConnectionTask !== 0) {
      obj.negativeConnectionTask = Math.round(message.negativeConnectionTask);
    }
    if (message.application !== 0) {
      obj.application = Math.round(message.application);
    }
    if (message.resourceAssignment !== "") {
      obj.resourceAssignment = message.resourceAssignment;
    }
    if (message.node !== "") {
      obj.node = message.node;
    }
    if (message.nodeLineCard !== 0) {
      obj.nodeLineCard = Math.round(message.nodeLineCard);
    }
    if (message.nodePort !== 0) {
      obj.nodePort = Math.round(message.nodePort);
    }
    if (message.nodeBreakout !== 0) {
      obj.nodeBreakout = Math.round(message.nodeBreakout);
    }
    if (message.tenantMetadata !== 0) {
      obj.tenantMetadata = Math.round(message.tenantMetadata);
    }
    if (message.assertPortNoUnknownVlanFound !== 0) {
      obj.assertPortNoUnknownVlanFound = Math.round(message.assertPortNoUnknownVlanFound);
    }
    if (message.assertConfigPortNoUnknownVlanFound !== 0) {
      obj.assertConfigPortNoUnknownVlanFound = Math.round(message.assertConfigPortNoUnknownVlanFound);
    }
    if (message.bulkUpliftJobRequest !== "") {
      obj.bulkUpliftJobRequest = message.bulkUpliftJobRequest;
    }
    if (message.bulkUpliftJobStatus !== "") {
      obj.bulkUpliftJobStatus = message.bulkUpliftJobStatus;
    }
    if (message.bgpNeighborInfo !== "") {
      obj.bgpNeighborInfo = message.bgpNeighborInfo;
    }
    if (message.refPoint !== "") {
      obj.refPoint = message.refPoint;
    }
    if (message.refPointStatus !== "") {
      obj.refPointStatus = message.refPointStatus;
    }
    if (message.userPreferenceItem !== "") {
      obj.userPreferenceItem = message.userPreferenceItem;
    }
    if (message.bgpNeighborReceivedRoute !== "") {
      obj.bgpNeighborReceivedRoute = message.bgpNeighborReceivedRoute;
    }
    if (message.userEula !== "") {
      obj.userEula = message.userEula;
    }
    if (message.brigSymmetricSigningKey !== 0) {
      obj.brigSymmetricSigningKey = Math.round(message.brigSymmetricSigningKey);
    }
    if (message.firmwareVersion !== 0) {
      obj.firmwareVersion = Math.round(message.firmwareVersion);
    }
    if (message.serverIpRouteAddress !== "") {
      obj.serverIpRouteAddress = message.serverIpRouteAddress;
    }
    if (message.serverIpRouteTable !== "") {
      obj.serverIpRouteTable = message.serverIpRouteTable;
    }
    if (message.apiPathProtocol !== 0) {
      obj.apiPathProtocol = Math.round(message.apiPathProtocol);
    }
    if (message.serverPsu !== "") {
      obj.serverPsu = message.serverPsu;
    }
    if (message.serverTempSensor !== 0) {
      obj.serverTempSensor = Math.round(message.serverTempSensor);
    }
    if (message.loadBalancedSvcRoute !== 0) {
      obj.loadBalancedSvcRoute = Math.round(message.loadBalancedSvcRoute);
    }
    if (message.assignmentSvcRoute !== "") {
      obj.assignmentSvcRoute = message.assignmentSvcRoute;
    }
    if (message.dbTableUpdateNotification !== 0) {
      obj.dbTableUpdateNotification = Math.round(message.dbTableUpdateNotification);
    }
    if (message.assertDeviceFanSpeedBelowThreshold !== 0) {
      obj.assertDeviceFanSpeedBelowThreshold = Math.round(message.assertDeviceFanSpeedBelowThreshold);
    }
    if (message.assertConfigDeviceFanSpeedBelowThreshold !== 0) {
      obj.assertConfigDeviceFanSpeedBelowThreshold = Math.round(message.assertConfigDeviceFanSpeedBelowThreshold);
    }
    if (message.assertDeviceTemperatureBelowThreshold !== 0) {
      obj.assertDeviceTemperatureBelowThreshold = Math.round(message.assertDeviceTemperatureBelowThreshold);
    }
    if (message.assertConfigDeviceTemperatureBelowThreshold !== 0) {
      obj.assertConfigDeviceTemperatureBelowThreshold = Math.round(message.assertConfigDeviceTemperatureBelowThreshold);
    }
    if (message.activeWorker !== "") {
      obj.activeWorker = message.activeWorker;
    }
    if (message.serverFan !== 0) {
      obj.serverFan = Math.round(message.serverFan);
    }
    if (message.serverPortInfo !== 0) {
      obj.serverPortInfo = Math.round(message.serverPortInfo);
    }
    if (message.assertDevicePsuUsageBelowThreshold !== 0) {
      obj.assertDevicePsuUsageBelowThreshold = Math.round(message.assertDevicePsuUsageBelowThreshold);
    }
    if (message.assertConfigDevicePsuUsageBelowThreshold !== 0) {
      obj.assertConfigDevicePsuUsageBelowThreshold = Math.round(message.assertConfigDevicePsuUsageBelowThreshold);
    }
    if (message.bmcServer !== "") {
      obj.bmcServer = message.bmcServer;
    }
    if (message.bmcServerPsu !== "") {
      obj.bmcServerPsu = message.bmcServerPsu;
    }
    if (message.bmcServerTempSensor !== 0) {
      obj.bmcServerTempSensor = Math.round(message.bmcServerTempSensor);
    }
    if (message.bmcServerFan !== 0) {
      obj.bmcServerFan = Math.round(message.bmcServerFan);
    }
    if (message.bmcServerPortInfo !== 0) {
      obj.bmcServerPortInfo = Math.round(message.bmcServerPortInfo);
    }
    if (message.ipRouteJoinedView !== 0) {
      obj.ipRouteJoinedView = Math.round(message.ipRouteJoinedView);
    }
    if (message.serverToBmc !== 0) {
      obj.serverToBmc = Math.round(message.serverToBmc);
    }
    if (message.serverMac !== "") {
      obj.serverMac = message.serverMac;
    }
    if (message.serverInterface !== "") {
      obj.serverInterface = message.serverInterface;
    }
    if (message.serverL3Table !== "") {
      obj.serverL3Table = message.serverL3Table;
    }
    if (message.serverInterfaceInfo !== "") {
      obj.serverInterfaceInfo = message.serverInterfaceInfo;
    }
    if (message.pluggableConnectionInfo !== 0) {
      obj.pluggableConnectionInfo = Math.round(message.pluggableConnectionInfo);
    }
    if (message.ipRouteJoinedViewCountSpace !== "") {
      obj.ipRouteJoinedViewCountSpace = message.ipRouteJoinedViewCountSpace;
    }
    if (message.ipRouteJoinedViewCount !== 0) {
      obj.ipRouteJoinedViewCount = Math.round(message.ipRouteJoinedViewCount);
    }
    if (message.l2FdbBucketed !== "") {
      obj.l2FdbBucketed = message.l2FdbBucketed;
    }
    if (message.l2FdbSingle !== "") {
      obj.l2FdbSingle = message.l2FdbSingle;
    }
    if (message.l2FdbSingleVlan !== 0) {
      obj.l2FdbSingleVlan = Math.round(message.l2FdbSingleVlan);
    }
    if (message.signingKey !== "") {
      obj.signingKey = message.signingKey;
    }
    if (message.bgpNeighborAdvertisedRoute !== "") {
      obj.bgpNeighborAdvertisedRoute = message.bgpNeighborAdvertisedRoute;
    }
    if (message.serverInterfaceMapping !== 0) {
      obj.serverInterfaceMapping = Math.round(message.serverInterfaceMapping);
    }
    if (message.signingKeyFlavor !== 0) {
      obj.signingKeyFlavor = Math.round(message.signingKeyFlavor);
    }
    if (message.ipSlaProbe !== "") {
      obj.ipSlaProbe = message.ipSlaProbe;
    }
    if (message.staticRoute !== "") {
      obj.staticRoute = message.staticRoute;
    }
    if (message.interconnect !== "") {
      obj.interconnect = message.interconnect;
    }
    if (message.interconnectTransaction !== "0") {
      obj.interconnectTransaction = message.interconnectTransaction;
    }
    if (message.orgMetadata !== 0) {
      obj.orgMetadata = Math.round(message.orgMetadata);
    }
    if (message.fabricInterconnectConfig !== "") {
      obj.fabricInterconnectConfig = message.fabricInterconnectConfig;
    }
    if (message.spanSession !== "") {
      obj.spanSession = message.spanSession;
    }
    if (message.portVlanInfo !== 0) {
      obj.portVlanInfo = Math.round(message.portVlanInfo);
    }
    if (message.bgpRouteStats !== 0) {
      obj.bgpRouteStats = Math.round(message.bgpRouteStats);
    }
    if (message.vniMacCounts !== 0) {
      obj.vniMacCounts = Math.round(message.vniMacCounts);
    }
    if (message.gpuDevice !== 0) {
      obj.gpuDevice = Math.round(message.gpuDevice);
    }
    if (message.vxlanTunnel !== "") {
      obj.vxlanTunnel = message.vxlanTunnel;
    }
    if (message.vxlanTunnelMapping !== "") {
      obj.vxlanTunnelMapping = message.vxlanTunnelMapping;
    }
    if (message.vxlanRemoteVtepMapping !== "") {
      obj.vxlanRemoteVtepMapping = message.vxlanRemoteVtepMapping;
    }
    if (message.assertConfigMultisiteLinkUp !== 0) {
      obj.assertConfigMultisiteLinkUp = Math.round(message.assertConfigMultisiteLinkUp);
    }
    if (message.assertMultisiteLinkUp !== 0) {
      obj.assertMultisiteLinkUp = Math.round(message.assertMultisiteLinkUp);
    }
    if (message.multisiteLink !== "") {
      obj.multisiteLink = message.multisiteLink;
    }
    if (message.twampSession !== 0) {
      obj.twampSession = Math.round(message.twampSession);
    }
    if (message.assertConfigPortQsfpHealthy !== 0) {
      obj.assertConfigPortQsfpHealthy = Math.round(message.assertConfigPortQsfpHealthy);
    }
    if (message.assertPortQsfpHealthy !== 0) {
      obj.assertPortQsfpHealthy = Math.round(message.assertPortQsfpHealthy);
    }
    if (message.assertConfigMultisiteLatencyStable !== 0) {
      obj.assertConfigMultisiteLatencyStable = Math.round(message.assertConfigMultisiteLatencyStable);
    }
    if (message.assertMultisiteLatencyStable !== 0) {
      obj.assertMultisiteLatencyStable = Math.round(message.assertMultisiteLatencyStable);
    }
    if (message.l2FdbBucketedMultisite !== "") {
      obj.l2FdbBucketedMultisite = message.l2FdbBucketedMultisite;
    }
    if (message.commandRequest !== "") {
      obj.commandRequest = message.commandRequest;
    }
    if (message.commandOutput !== "") {
      obj.commandOutput = message.commandOutput;
    }
    if (message.commandOutputRecord !== 0) {
      obj.commandOutputRecord = Math.round(message.commandOutputRecord);
    }
    if (message.assertConfigMultisiteExpectedMtu !== 0) {
      obj.assertConfigMultisiteExpectedMtu = Math.round(message.assertConfigMultisiteExpectedMtu);
    }
    if (message.assertMultisiteExpectedMtu !== 0) {
      obj.assertMultisiteExpectedMtu = Math.round(message.assertMultisiteExpectedMtu);
    }
    if (message.imageManifestInfo !== 0) {
      obj.imageManifestInfo = Math.round(message.imageManifestInfo);
    }
    if (message.ipRouteFabricJoinedViewCountSpace !== "") {
      obj.ipRouteFabricJoinedViewCountSpace = message.ipRouteFabricJoinedViewCountSpace;
    }
    if (message.ipRouteFabricJoinedViewCount !== 0) {
      obj.ipRouteFabricJoinedViewCount = Math.round(message.ipRouteFabricJoinedViewCount);
    }
    if (message.borderPort !== 0) {
      obj.borderPort = Math.round(message.borderPort);
    }
    if (message.networkInterfaceSummary !== "") {
      obj.networkInterfaceSummary = message.networkInterfaceSummary;
    }
    if (message.vrfEndpointCounts !== "") {
      obj.vrfEndpointCounts = message.vrfEndpointCounts;
    }
    if (message.assertConfigNxosDeviceExpectedFeatures !== 0) {
      obj.assertConfigNxosDeviceExpectedFeatures = Math.round(message.assertConfigNxosDeviceExpectedFeatures);
    }
    if (message.assertNxosDeviceExpectedFeatures !== 0) {
      obj.assertNxosDeviceExpectedFeatures = Math.round(message.assertNxosDeviceExpectedFeatures);
    }
    if (message.opticsFirmwareUpdate !== 0) {
      obj.opticsFirmwareUpdate = Math.round(message.opticsFirmwareUpdate);
    }
    if (message.arsConfig !== "") {
      obj.arsConfig = message.arsConfig;
    }
    if (message.softwareUpdateStatus !== 0) {
      obj.softwareUpdateStatus = Math.round(message.softwareUpdateStatus);
    }
    if (message.vxlanRemoteVtepInfo !== "") {
      obj.vxlanRemoteVtepInfo = message.vxlanRemoteVtepInfo;
    }
    if (message.arsInfo !== 0) {
      obj.arsInfo = Math.round(message.arsInfo);
    }
    if (message.cellPair !== "") {
      obj.cellPair = message.cellPair;
    }
    if (message.arsPortInfo !== 0) {
      obj.arsPortInfo = Math.round(message.arsPortInfo);
    }
    if (message.fabricRack !== "") {
      obj.fabricRack = message.fabricRack;
    }
    if (message.iterativeSpiderClaim !== "") {
      obj.iterativeSpiderClaim = message.iterativeSpiderClaim;
    }
    if (message.invalidUserSession !== "") {
      obj.invalidUserSession = message.invalidUserSession;
    }
    if (message.systemHealth !== 0) {
      obj.systemHealth = Math.round(message.systemHealth);
    }
    if (message.portVlanAssertSummary !== "") {
      obj.portVlanAssertSummary = message.portVlanAssertSummary;
    }
    if (message.serverNetworkAdapter !== "") {
      obj.serverNetworkAdapter = message.serverNetworkAdapter;
    }
    if (message.bmcServerNetworkAdapter !== "") {
      obj.bmcServerNetworkAdapter = message.bmcServerNetworkAdapter;
    }
    if (message.serverProcessor !== "") {
      obj.serverProcessor = message.serverProcessor;
    }
    if (message.bmcServerProcessor !== "") {
      obj.bmcServerProcessor = message.bmcServerProcessor;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PathId>, I>>(base?: I): PathId {
    return PathId.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PathId>, I>>(object: I): PathId {
    const message = createBasePathId();
    message.deleted = object.deleted ?? false;
    message.pathString = object.pathString ?? "";
    message.type = object.type ?? 0;
    message.fabric = object.fabric ?? "";
    message.device = object.device ?? "";
    message.fan = object.fan ?? 0;
    message.psu = object.psu ?? 0;
    message.tempSensor = object.tempSensor ?? 0;
    message.lineCard = object.lineCard ?? 0;
    message.port = object.port ?? 0;
    message.dacQsfp = object.dacQsfp ?? 0;
    message.fiberQsfp = object.fiberQsfp ?? 0;
    message.breakout = object.breakout ?? 0;
    message.portNeighbor = object.portNeighbor ?? "";
    message.vtep = object.vtep ?? 0;
    message.vniPort = object.vniPort ?? 0;
    message.mac = object.mac ?? 0;
    message.procTable = object.procTable ?? 0;
    message.portVlan = object.portVlan ?? "";
    message.vlanState = object.vlanState ?? 0;
    message.qsfpDomSensor = object.qsfpDomSensor ?? 0;
    message.portConfig = object.portConfig ?? 0;
    message.nodeConfig = object.nodeConfig ?? 0;
    message.fabricConfig = object.fabricConfig ?? "";
    message.fabricConfigEvent = object.fabricConfigEvent ?? 0;
    message.l2Fdb = object.l2Fdb ?? 0;
    message.portCounters = object.portCounters ?? 0;
    message.remedyAction = object.remedyAction ?? "";
    message.qsfpInfo = object.qsfpInfo ?? 0;
    message.fabricDevice = object.fabricDevice ?? "";
    message.assertConfigPortLinkUp = object.assertConfigPortLinkUp ?? 0;
    message.assertPortLinkUp = object.assertPortLinkUp ?? 0;
    message.assertConfigDeviceConnectedToCloud = object.assertConfigDeviceConnectedToCloud ?? 0;
    message.assertDeviceConnectedToCloud = object.assertDeviceConnectedToCloud ?? 0;
    message.assertConfigPortExpectedNeighbor = object.assertConfigPortExpectedNeighbor ?? 0;
    message.assertPortExpectedNeighbor = object.assertPortExpectedNeighbor ?? 0;
    message.assertConfigPortNotConnectedToFabric = object.assertConfigPortNotConnectedToFabric ?? 0;
    message.assertPortNotConnectedToFabric = object.assertPortNotConnectedToFabric ?? 0;
    message.assertConfigDeviceConnectedToFabric = object.assertConfigDeviceConnectedToFabric ?? 0;
    message.assertDeviceConnectedToFabric = object.assertDeviceConnectedToFabric ?? 0;
    message.assertConfigPortLinkDown = object.assertConfigPortLinkDown ?? 0;
    message.assertPortLinkDown = object.assertPortLinkDown ?? 0;
    message.assertConfigPortConnectionSpeedMatch = object.assertConfigPortConnectionSpeedMatch ?? 0;
    message.assertPortConnectionSpeedMatch = object.assertPortConnectionSpeedMatch ?? 0;
    message.assertConfigPortSpeedConsistent = object.assertConfigPortSpeedConsistent ?? 0;
    message.assertPortSpeedConsistent = object.assertPortSpeedConsistent ?? 0;
    message.underlayInfo = object.underlayInfo ?? 0;
    message.proxyStats = object.proxyStats ?? 0;
    message.vlanCounters = object.vlanCounters ?? 0;
    message.testPlaceHolder1Secret = object.testPlaceHolder1Secret ?? 0;
    message.assertConfigVlanHasTraffic = object.assertConfigVlanHasTraffic ?? 0;
    message.assertVlanHasTraffic = object.assertVlanHasTraffic ?? 0;
    message.remoteVtep = object.remoteVtep ?? 0;
    message.qsfpDomThreshold = object.qsfpDomThreshold ?? 0;
    message.l3Table = object.l3Table ?? "";
    message.vlanVniMap = object.vlanVniMap ?? 0;
    message.proxyConnectionState = object.proxyConnectionState ?? "";
    message.proxyConnectionStats = object.proxyConnectionStats ?? 0;
    message.l2Mac = object.l2Mac ?? "";
    message.bmc = object.bmc ?? 0;
    message.ipRouteTable = object.ipRouteTable ?? "";
    message.vrf = object.vrf ?? "";
    message.ipNextHop = object.ipNextHop ?? 0;
    message.ipPrefix = object.ipPrefix ?? "";
    message.subInterface = object.subInterface ?? 0;
    message.assertConfigStaticDefaultRouteExists = object.assertConfigStaticDefaultRouteExists ?? 0;
    message.assertStaticDefaultRouteExists = object.assertStaticDefaultRouteExists ?? 0;
    message.spyglassBrokerEntry = object.spyglassBrokerEntry ?? "";
    message.managementState = object.managementState ?? "";
    message.assertConfigManagementPortConfigSame = object.assertConfigManagementPortConfigSame ?? 0;
    message.assertManagementPortConfigSame = object.assertManagementPortConfigSame ?? 0;
    message.fabricConfigNotification = object.fabricConfigNotification ?? 0;
    message.spyglassGingerEntry = object.spyglassGingerEntry ?? 0;
    message.plannedConfig = object.plannedConfig ?? 0;
    message.routedInterfaceCounters = object.routedInterfaceCounters ?? 0;
    message.ipmRawLatencyCounters = object.ipmRawLatencyCounters ?? 0;
    message.ipmProcLatencyCounters = object.ipmProcLatencyCounters ?? 0;
    message.ipmProcLossCounters = object.ipmProcLossCounters ?? 0;
    message.ipmLivenessCounters = object.ipmLivenessCounters ?? 0;
    message.ipmSessionId = object.ipmSessionId ?? "";
    message.ipmProcJitterCounters = object.ipmProcJitterCounters ?? 0;
    message.systemStats = object.systemStats ?? 0;
    message.testRootOne = object.testRootOne ?? "";
    message.testRootTwo = object.testRootTwo ?? "";
    message.testMidOne = object.testMidOne ?? 0;
    message.testLeafOne = object.testLeafOne ?? "";
    message.testIpAddress = object.testIpAddress ?? "";
    message.testIpPrefix = object.testIpPrefix ?? "";
    message.testMacAddress = object.testMacAddress ?? "";
    message.assertConfigDeviceResourceUsageBelowThreshold = object.assertConfigDeviceResourceUsageBelowThreshold ?? 0;
    message.assertDeviceResourceUsageBelowThreshold = object.assertDeviceResourceUsageBelowThreshold ?? 0;
    message.fabricTransaction = object.fabricTransaction ?? "0";
    message.bgpNeighborSummary = object.bgpNeighborSummary ?? "";
    message.deviceConnection = object.deviceConnection ?? 0;
    message.bgpNeighborFamily = object.bgpNeighborFamily ?? 0;
    message.assertConfigBgpPeerEstablished = object.assertConfigBgpPeerEstablished ?? 0;
    message.assertBgpPeerEstablished = object.assertBgpPeerEstablished ?? 0;
    message.spyglassSshSessionEntry = object.spyglassSshSessionEntry ?? 0;
    message.portChannelMemberState = object.portChannelMemberState ?? "";
    message.portChannelState = object.portChannelState ?? "";
    message.spyglassDevice = object.spyglassDevice ?? "";
    message.spyglassTcpListener = object.spyglassTcpListener ?? 0;
    message.spyglassTcpSession = object.spyglassTcpSession ?? 0;
    message.unknownVlan = object.unknownVlan ?? 0;
    message.unknownVlanPort = object.unknownVlanPort ?? "";
    message.assertConfigExpectedPortBreakoutExists = object.assertConfigExpectedPortBreakoutExists ?? 0;
    message.assertExpectedPortBreakoutExists = object.assertExpectedPortBreakoutExists ?? 0;
    message.assertConfigSubInterfaceUp = object.assertConfigSubInterfaceUp ?? 0;
    message.assertSubInterfaceUp = object.assertSubInterfaceUp ?? 0;
    message.assertSubInterfaceDown = object.assertSubInterfaceDown ?? 0;
    message.assertConfigSubInterfaceDown = object.assertConfigSubInterfaceDown ?? 0;
    message.deviceClaim = object.deviceClaim ?? 0;
    message.aggregatedDeviceClaim = object.aggregatedDeviceClaim ?? "";
    message.assertPortChannelMemberUp = object.assertPortChannelMemberUp ?? 0;
    message.assertConfigPortChannelMemberUp = object.assertConfigPortChannelMemberUp ?? 0;
    message.esiInfo = object.esiInfo ?? "";
    message.esiVtepInfo = object.esiVtepInfo ?? "";
    message.assertPortVlanStpStateConsistent = object.assertPortVlanStpStateConsistent ?? 0;
    message.assertConfigPortVlanStpStateConsistent = object.assertConfigPortVlanStpStateConsistent ?? 0;
    message.assertPortPluggablePidSame = object.assertPortPluggablePidSame ?? 0;
    message.assertConfigPortPluggablePidSame = object.assertConfigPortPluggablePidSame ?? 0;
    message.manifestImageState = object.manifestImageState ?? 0;
    message.portRateCounters = object.portRateCounters ?? 0;
    message.authorizedUserEntry = object.authorizedUserEntry ?? "";
    message.delegatedReadOnlyUserEntry = object.delegatedReadOnlyUserEntry ?? "";
    message.orgUuid = object.orgUuid ?? "";
    message.fabricUuid = object.fabricUuid ?? "";
    message.apiPath = object.apiPath ?? "";
    message.apiPathMethod = object.apiPathMethod ?? "";
    message.apiServiceMapping = object.apiServiceMapping ?? 0;
    message.orgToCellPairMapping = object.orgToCellPairMapping ?? 0;
    message.tenantUuid = object.tenantUuid ?? "";
    message.userEmail = object.userEmail ?? "";
    message.managementConfig = object.managementConfig ?? 0;
    message.serviceInstanceHealth = object.serviceInstanceHealth ?? "";
    message.assignmentStatus = object.assignmentStatus ?? "";
    message.kubernetesServiceInstance = object.kubernetesServiceInstance ?? "";
    message.bearerToken = object.bearerToken ?? "";
    message.apiKey = object.apiKey ?? "";
    message.fabricMemoryUsage = object.fabricMemoryUsage ?? "";
    message.typeMemoryUsage = object.typeMemoryUsage ?? 0;
    message.manifestRunningImageStatus = object.manifestRunningImageStatus ?? 0;
    message.manifestPartitionFileCacheStatus = object.manifestPartitionFileCacheStatus ?? "";
    message.stpPortState = object.stpPortState ?? "";
    message.stpVlanState = object.stpVlanState ?? 0;
    message.stpVlanPortState = object.stpVlanPortState ?? "";
    message.unpackAndAssembleTask = object.unpackAndAssembleTask ?? 0;
    message.claimAndBindTask = object.claimAndBindTask ?? 0;
    message.portSetupTask = object.portSetupTask ?? 0;
    message.fabricConnectionTask = object.fabricConnectionTask ?? 0;
    message.negativeConnectionTask = object.negativeConnectionTask ?? 0;
    message.application = object.application ?? 0;
    message.resourceAssignment = object.resourceAssignment ?? "";
    message.node = object.node ?? "";
    message.nodeLineCard = object.nodeLineCard ?? 0;
    message.nodePort = object.nodePort ?? 0;
    message.nodeBreakout = object.nodeBreakout ?? 0;
    message.tenantMetadata = object.tenantMetadata ?? 0;
    message.assertPortNoUnknownVlanFound = object.assertPortNoUnknownVlanFound ?? 0;
    message.assertConfigPortNoUnknownVlanFound = object.assertConfigPortNoUnknownVlanFound ?? 0;
    message.bulkUpliftJobRequest = object.bulkUpliftJobRequest ?? "";
    message.bulkUpliftJobStatus = object.bulkUpliftJobStatus ?? "";
    message.bgpNeighborInfo = object.bgpNeighborInfo ?? "";
    message.refPoint = object.refPoint ?? "";
    message.refPointStatus = object.refPointStatus ?? "";
    message.userPreferenceItem = object.userPreferenceItem ?? "";
    message.bgpNeighborReceivedRoute = object.bgpNeighborReceivedRoute ?? "";
    message.userEula = object.userEula ?? "";
    message.brigSymmetricSigningKey = object.brigSymmetricSigningKey ?? 0;
    message.firmwareVersion = object.firmwareVersion ?? 0;
    message.serverIpRouteAddress = object.serverIpRouteAddress ?? "";
    message.serverIpRouteTable = object.serverIpRouteTable ?? "";
    message.apiPathProtocol = object.apiPathProtocol ?? 0;
    message.serverPsu = object.serverPsu ?? "";
    message.serverTempSensor = object.serverTempSensor ?? 0;
    message.loadBalancedSvcRoute = object.loadBalancedSvcRoute ?? 0;
    message.assignmentSvcRoute = object.assignmentSvcRoute ?? "";
    message.dbTableUpdateNotification = object.dbTableUpdateNotification ?? 0;
    message.assertDeviceFanSpeedBelowThreshold = object.assertDeviceFanSpeedBelowThreshold ?? 0;
    message.assertConfigDeviceFanSpeedBelowThreshold = object.assertConfigDeviceFanSpeedBelowThreshold ?? 0;
    message.assertDeviceTemperatureBelowThreshold = object.assertDeviceTemperatureBelowThreshold ?? 0;
    message.assertConfigDeviceTemperatureBelowThreshold = object.assertConfigDeviceTemperatureBelowThreshold ?? 0;
    message.activeWorker = object.activeWorker ?? "";
    message.serverFan = object.serverFan ?? 0;
    message.serverPortInfo = object.serverPortInfo ?? 0;
    message.assertDevicePsuUsageBelowThreshold = object.assertDevicePsuUsageBelowThreshold ?? 0;
    message.assertConfigDevicePsuUsageBelowThreshold = object.assertConfigDevicePsuUsageBelowThreshold ?? 0;
    message.bmcServer = object.bmcServer ?? "";
    message.bmcServerPsu = object.bmcServerPsu ?? "";
    message.bmcServerTempSensor = object.bmcServerTempSensor ?? 0;
    message.bmcServerFan = object.bmcServerFan ?? 0;
    message.bmcServerPortInfo = object.bmcServerPortInfo ?? 0;
    message.ipRouteJoinedView = object.ipRouteJoinedView ?? 0;
    message.serverToBmc = object.serverToBmc ?? 0;
    message.serverMac = object.serverMac ?? "";
    message.serverInterface = object.serverInterface ?? "";
    message.serverL3Table = object.serverL3Table ?? "";
    message.serverInterfaceInfo = object.serverInterfaceInfo ?? "";
    message.pluggableConnectionInfo = object.pluggableConnectionInfo ?? 0;
    message.ipRouteJoinedViewCountSpace = object.ipRouteJoinedViewCountSpace ?? "";
    message.ipRouteJoinedViewCount = object.ipRouteJoinedViewCount ?? 0;
    message.l2FdbBucketed = object.l2FdbBucketed ?? "";
    message.l2FdbSingle = object.l2FdbSingle ?? "";
    message.l2FdbSingleVlan = object.l2FdbSingleVlan ?? 0;
    message.signingKey = object.signingKey ?? "";
    message.bgpNeighborAdvertisedRoute = object.bgpNeighborAdvertisedRoute ?? "";
    message.serverInterfaceMapping = object.serverInterfaceMapping ?? 0;
    message.signingKeyFlavor = object.signingKeyFlavor ?? 0;
    message.ipSlaProbe = object.ipSlaProbe ?? "";
    message.staticRoute = object.staticRoute ?? "";
    message.interconnect = object.interconnect ?? "";
    message.interconnectTransaction = object.interconnectTransaction ?? "0";
    message.orgMetadata = object.orgMetadata ?? 0;
    message.fabricInterconnectConfig = object.fabricInterconnectConfig ?? "";
    message.spanSession = object.spanSession ?? "";
    message.portVlanInfo = object.portVlanInfo ?? 0;
    message.bgpRouteStats = object.bgpRouteStats ?? 0;
    message.vniMacCounts = object.vniMacCounts ?? 0;
    message.gpuDevice = object.gpuDevice ?? 0;
    message.vxlanTunnel = object.vxlanTunnel ?? "";
    message.vxlanTunnelMapping = object.vxlanTunnelMapping ?? "";
    message.vxlanRemoteVtepMapping = object.vxlanRemoteVtepMapping ?? "";
    message.assertConfigMultisiteLinkUp = object.assertConfigMultisiteLinkUp ?? 0;
    message.assertMultisiteLinkUp = object.assertMultisiteLinkUp ?? 0;
    message.multisiteLink = object.multisiteLink ?? "";
    message.twampSession = object.twampSession ?? 0;
    message.assertConfigPortQsfpHealthy = object.assertConfigPortQsfpHealthy ?? 0;
    message.assertPortQsfpHealthy = object.assertPortQsfpHealthy ?? 0;
    message.assertConfigMultisiteLatencyStable = object.assertConfigMultisiteLatencyStable ?? 0;
    message.assertMultisiteLatencyStable = object.assertMultisiteLatencyStable ?? 0;
    message.l2FdbBucketedMultisite = object.l2FdbBucketedMultisite ?? "";
    message.commandRequest = object.commandRequest ?? "";
    message.commandOutput = object.commandOutput ?? "";
    message.commandOutputRecord = object.commandOutputRecord ?? 0;
    message.assertConfigMultisiteExpectedMtu = object.assertConfigMultisiteExpectedMtu ?? 0;
    message.assertMultisiteExpectedMtu = object.assertMultisiteExpectedMtu ?? 0;
    message.imageManifestInfo = object.imageManifestInfo ?? 0;
    message.ipRouteFabricJoinedViewCountSpace = object.ipRouteFabricJoinedViewCountSpace ?? "";
    message.ipRouteFabricJoinedViewCount = object.ipRouteFabricJoinedViewCount ?? 0;
    message.borderPort = object.borderPort ?? 0;
    message.networkInterfaceSummary = object.networkInterfaceSummary ?? "";
    message.vrfEndpointCounts = object.vrfEndpointCounts ?? "";
    message.assertConfigNxosDeviceExpectedFeatures = object.assertConfigNxosDeviceExpectedFeatures ?? 0;
    message.assertNxosDeviceExpectedFeatures = object.assertNxosDeviceExpectedFeatures ?? 0;
    message.opticsFirmwareUpdate = object.opticsFirmwareUpdate ?? 0;
    message.arsConfig = object.arsConfig ?? "";
    message.softwareUpdateStatus = object.softwareUpdateStatus ?? 0;
    message.vxlanRemoteVtepInfo = object.vxlanRemoteVtepInfo ?? "";
    message.arsInfo = object.arsInfo ?? 0;
    message.cellPair = object.cellPair ?? "";
    message.arsPortInfo = object.arsPortInfo ?? 0;
    message.fabricRack = object.fabricRack ?? "";
    message.iterativeSpiderClaim = object.iterativeSpiderClaim ?? "";
    message.invalidUserSession = object.invalidUserSession ?? "";
    message.systemHealth = object.systemHealth ?? 0;
    message.portVlanAssertSummary = object.portVlanAssertSummary ?? "";
    message.serverNetworkAdapter = object.serverNetworkAdapter ?? "";
    message.bmcServerNetworkAdapter = object.bmcServerNetworkAdapter ?? "";
    message.serverProcessor = object.serverProcessor ?? "";
    message.bmcServerProcessor = object.bmcServerProcessor ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
